// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%27160%27 height=%27160%27><filter id=%27n%27><feTurbulence baseFrequency=%270.9%27 numOctaves=%272%27/></filter><rect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27 opacity=%271%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Chivo:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: JetBrains Mono, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

:root,
  .dark {
    /* ── Deep space palette (colored darks, not flat black) ── */
    --bg:           228 32% 7%;    /* #0A0E18 */
    --bg-paper:     230 28% 11%;   /* #121826 */
    --bg-surface:   232 26% 15%;   /* #1A2234 */
    --ink:          210 40% 97%;   /* #F5F9FC */
    --ink-mute:     215 22% 68%;   /* #A3B2C8 */
    --ink-dim:      215 16% 50%;   /* #6E809A */
    --line:         228 22% 24%;   /* #2E3648 */
    --line-subtle:  228 22% 16%;
    --accent-cyan:  192 100% 50%;  /* #00D4FF */
    --accent-amber: 38 92% 50%;    /* #F59E0B */
    --accent-violet:270 80% 65%;   /* #9B59F5 */
    --grid-line:    255 255 255 / 0.04;
    --hero-grad-1:  0 212 255 / 0.08;
    --hero-grad-2:  245 158 11 / 0.06;
    --bg-noise:     0.025;
    --orb-opacity:  0.6;
    --bg-section:   228 28% 9%;
    --bg-card-a:    215 32% 13%;   /* deep cyan-slate */
    --bg-card-b:    235 28% 15%;   /* navy blue */
    --bg-card-c:    252 24% 17%;   /* deep violet-slate */
  }

.light {
    --bg:           220 22% 97%;
    --bg-paper:     220 20% 94%;
    --bg-surface:   220 18% 90%;
    --ink:          224 50% 9%;
    --ink-mute:     215 18% 32%;
    --ink-dim:      215 14% 45%;
    --line:         220 18% 82%;
    --line-subtle:  220 18% 90%;
    --accent-cyan:  193 90% 26%;
    --accent-amber: 32 92% 30%;
    --accent-violet:270 70% 45%;
    --grid-line:    0 0 0 / 0.04;
    --hero-grad-1:  0 212 255 / 0.10;
    --hero-grad-2:  245 158 11 / 0.08;
    --bg-noise:     0.012;
    --orb-opacity:  0.22;
    --bg-section:   215 24% 93%;
    --bg-card-a:    220 26% 99%;
    --bg-card-b:    215 24% 95%;
    --bg-card-c:    220 20% 97%;
  }

html { scroll-behavior: smooth; }

body{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bg) / var(--tw-bg-opacity, 1));
  font-family: Chivo, sans-serif;
  --tw-text-opacity: 1;
  color: hsl(var(--ink) / var(--tw-text-opacity, 1));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    transition: background-color 0.35s ease, color 0.35s ease;
}

h1, h2, h3, h4{
  font-family: Outfit, sans-serif;
  --tw-text-opacity: 1;
  color: hsl(var(--ink) / var(--tw-text-opacity, 1));
}

::selection { background: #00D4FF33; color: #00D4FF; }
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-12{
  left: -3rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-12{
  right: -3rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-12{
  top: -3rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-2\\.5{
  bottom: 0.625rem;
}
.bottom-8{
  bottom: 2rem;
}
.bottom-\\[-100px\\]{
  bottom: -100px;
}
.bottom-\\[-150px\\]{
  bottom: -150px;
}
.bottom-\\[46px\\]{
  bottom: 46px;
}
.bottom-\\[88px\\]{
  bottom: 88px;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-\\[-100px\\]{
  left: -100px;
}
.left-\\[20\\%\\]{
  left: 20%;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-\\[-100px\\]{
  right: -100px;
}
.right-\\[-150px\\]{
  right: -150px;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-1\\/3{
  top: 33.333333%;
}
.top-2{
  top: 0.5rem;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-4{
  top: 1rem;
}
.top-\\[-100px\\]{
  top: -100px;
}
.top-\\[-150px\\]{
  top: -150px;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[52px\\]{
  top: 52px;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.m-0{
  margin: 0px;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-14{
  margin-bottom: 3.5rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-3\\.5{
  margin-bottom: 0.875rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-0{
  margin-right: 0px;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-\\[0\\.35em\\]{
  margin-right: 0.35em;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-11{
  margin-top: 2.75rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.block{
  display: block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[360px\\]{
  height: 360px;
}
.h-\\[4\\.5rem\\]{
  height: 4.5rem;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[440px\\]{
  height: 440px;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-full{
  max-height: 100%;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-\\[1px\\]{
  min-height: 1px;
}
.min-h-\\[220px\\]{
  min-height: 220px;
}
.min-h-\\[280px\\]{
  min-height: 280px;
}
.min-h-\\[36px\\]{
  min-height: 36px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0{
  width: 0px;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-4{
  width: 1rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[118px\\]{
  width: 118px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[360px\\]{
  width: 360px;
}
.w-\\[4\\.5rem\\]{
  width: 4.5rem;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[440px\\]{
  width: 440px;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[320px\\]{
  min-width: 320px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-\\[1080px\\]{
  max-width: 1080px;
}
.max-w-\\[620px\\]{
  max-width: 620px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-screen-2xl{
  max-width: 1536px;
}
.flex-1{
  flex: 1 1;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes pulse-glow{

  0%, 100%{
    opacity: 0.4;
  }

  50%{
    opacity: 1;
  }
}
.animate-pulse-glow{
  animation: pulse-glow 2.5s ease-in-out infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.list-none{
  list-style-type: none;
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-items-center{
  place-items: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-px{
  gap: 1px;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre{
  white-space: pre;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-tl-sm{
  border-top-left-radius: 0.125rem;
}
.\\!border{
  border-width: 1px !important;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-r{
  border-right-width: 1px;
}
.border-r-2{
  border-right-width: 2px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.\\!border-line{
  --tw-border-opacity: 1 !important;
  border-color: hsl(var(--line) / var(--tw-border-opacity, 1)) !important;
}
.border-amber\\/50{
  border-color: rgb(245 158 11 / 0.5);
}
.border-cyan{
  --tw-border-opacity: 1;
  border-color: rgb(0 212 255 / var(--tw-border-opacity, 1));
}
.border-cyan\\/20{
  border-color: rgb(0 212 255 / 0.2);
}
.border-cyan\\/50{
  border-color: rgb(0 212 255 / 0.5);
}
.border-line{
  --tw-border-opacity: 1;
  border-color: hsl(var(--line) / var(--tw-border-opacity, 1));
}
.border-line\\/20{
  border-color: hsl(var(--line) / 0.2);
}
.border-line\\/30{
  border-color: hsl(var(--line) / 0.3);
}
.border-line\\/40{
  border-color: hsl(var(--line) / 0.4);
}
.border-line\\/60{
  border-color: hsl(var(--line) / 0.6);
}
.border-line\\/65{
  border-color: hsl(var(--line) / 0.65);
}
.border-line\\/80{
  border-color: hsl(var(--line) / 0.8);
}
.border-transparent{
  border-color: transparent;
}
.border-white\\/80{
  border-color: rgb(255 255 255 / 0.8);
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.\\!bg-bg-paper{
  --tw-bg-opacity: 1 !important;
  background-color: hsl(var(--bg-paper) / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[hsl\\(var\\(--accent-cyan\\)\\/0\\.55\\)\\]{
  background-color: hsl(var(--accent-cyan)/0.55);
}
.bg-amber{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber\\/5{
  background-color: rgb(245 158 11 / 0.05);
}
.bg-bg{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bg) / var(--tw-bg-opacity, 1));
}
.bg-bg-paper{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bg-paper) / var(--tw-bg-opacity, 1));
}
.bg-bg-paper\\/40{
  background-color: hsl(var(--bg-paper) / 0.4);
}
.bg-bg-paper\\/60{
  background-color: hsl(var(--bg-paper) / 0.6);
}
.bg-bg-section{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bg-section) / var(--tw-bg-opacity, 1));
}
.bg-bg\\/60{
  background-color: hsl(var(--bg) / 0.6);
}
.bg-bg\\/85{
  background-color: hsl(var(--bg) / 0.85);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-card-a{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bg-card-a) / var(--tw-bg-opacity, 1));
}
.bg-card-b{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bg-card-b) / var(--tw-bg-opacity, 1));
}
.bg-card-c{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bg-card-c) / var(--tw-bg-opacity, 1));
}
.bg-cyan{
  --tw-bg-opacity: 1;
  background-color: rgb(0 212 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan\\/5{
  background-color: rgb(0 212 255 / 0.05);
}
.bg-cyan\\/50{
  background-color: rgb(0 212 255 / 0.5);
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-line{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--line) / var(--tw-bg-opacity, 1));
}
.bg-line\\/40{
  background-color: hsl(var(--line) / 0.4);
}
.bg-transparent{
  background-color: transparent;
}
.fill-current{
  fill: currentColor;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-left-bottom{
  object-position: left bottom;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.\\!py-24{
  padding-top: 6rem !important;
  padding-bottom: 6rem !important;
}
.\\!py-28{
  padding-top: 7rem !important;
  padding-bottom: 7rem !important;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.\\!pt-14{
  padding-top: 3.5rem !important;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-8{
  padding-left: 2rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-body{
  font-family: Chivo, sans-serif;
}
.font-heading{
  font-family: Outfit, sans-serif;
}
.font-mono{
  font-family: JetBrains Mono, monospace;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10\\.5px\\]{
  font-size: 10.5px;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13\\.5px\\]{
  font-size: 13.5px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-\\[clamp\\(1rem\\2c 1\\.7vw\\2c 1\\.1875rem\\)\\]{
  font-size: clamp(1rem,1.7vw,1.1875rem);
}
.text-\\[clamp\\(2\\.375rem\\2c 6vw\\2c 4\\.125rem\\)\\]{
  font-size: clamp(2.375rem,6vw,4.125rem);
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.normal-case{
  text-transform: none;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[1\\.02\\]{
  line-height: 1.02;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-tighter{
  letter-spacing: -0.05em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.tracking-widest2{
  letter-spacing: 0.2em;
}
.\\!text-ink{
  --tw-text-opacity: 1 !important;
  color: hsl(var(--ink) / var(--tw-text-opacity, 1)) !important;
}
.text-amber{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber\\/90{
  color: rgb(245 158 11 / 0.9);
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-current{
  color: currentColor;
}
.text-cyan{
  --tw-text-opacity: 1;
  color: rgb(0 212 255 / var(--tw-text-opacity, 1));
}
.text-ink{
  --tw-text-opacity: 1;
  color: hsl(var(--ink) / var(--tw-text-opacity, 1));
}
.text-ink-dim{
  --tw-text-opacity: 1;
  color: hsl(var(--ink-dim) / var(--tw-text-opacity, 1));
}
.text-ink-mute{
  --tw-text-opacity: 1;
  color: hsl(var(--ink-mute) / var(--tw-text-opacity, 1));
}
.text-ink-mute\\/80{
  color: hsl(var(--ink-mute) / 0.8);
}
.text-ink\\/90{
  color: hsl(var(--ink) / 0.9);
}
.text-line{
  --tw-text-opacity: 1;
  color: hsl(var(--line) / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/30{
  color: rgb(255 255 255 / 0.3);
}
.text-white\\/35{
  color: rgb(255 255 255 / 0.35);
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_80px_rgba\\(0\\2c 212\\2c 255\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 0 80px rgba(0,212,255,0.08);
  --tw-shadow-colored: 0 0 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-md{
  --tw-blur: blur(12px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-none{
  transition-property: none;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.running{
  animation-play-state: running;
}
.\\!paused{
  animation-play-state: paused !important;
}
.paused{
  animation-play-state: paused;
}
.container-x{
  margin-left: auto;
  margin-right: auto;
  max-width: 80rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
@media (min-width: 768px){

  .container-x{
    padding-left: 3rem;
    padding-right: 3rem;
  }
}
.label-eyebrow{
  font-family: JetBrains Mono, monospace;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2em;
}
.why-chain-step--active.why-chain-step--rival .label-eyebrow {
    color: #f59e0b;
    opacity: 1;
  }
.why-chain-step--active.why-chain-step--nai .label-eyebrow {
    opacity: 1;
  }
.why-chain-step--rival .label-eyebrow { color: hsl(var(--ink-dim)); }
.why-chain-step--nai .label-eyebrow { color: #00d4ff; opacity: 0.65; }
.label-eyebrow {
    color: hsl(var(--accent-cyan));
  }
/* ── Grid / texture ── */
.grid-bg {
    background-image:
      linear-gradient(rgb(var(--grid-line)) 1px, transparent 1px),
      linear-gradient(90deg, rgb(var(--grid-line)) 1px, transparent 1px);
    background-size: 56px 56px;
  }
.noise::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    opacity: var(--bg-noise);
    mix-blend-mode: overlay;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
.dot-pattern {
    background-image: radial-gradient(rgb(var(--grid-line)) 1px, transparent 1.5px);
    background-size: 18px 18px;
  }
/* ── Orbs ── */
.orb {
    position: absolute;
    border-radius: 9999px;
    filter: blur(100px);
    pointer-events: none;
    opacity: var(--orb-opacity);
  }
.orb-cyan    { background: radial-gradient(circle, rgba(0,212,255,0.5), transparent 70%); }
.orb-amber   { background: radial-gradient(circle, rgba(245,158,11,0.45), transparent 70%); }
.orb-violet  { background: radial-gradient(circle, rgba(155,89,245,0.4), transparent 70%); }
/* ── Flow ── */
.stroke-flow { stroke-dasharray: 4 8; animation: flow 3s linear infinite; }
/* ── Gradient text ── */
/* ── Theme accent text ── */
.text-accent-cyan   { color: hsl(var(--accent-cyan)); }
.text-accent-amber  { color: hsl(var(--accent-amber)); }
/* ── Site nav — soft default, cyan hover/active ── */
.site-nav-link {
    position: relative;
    color: hsl(var(--ink-mute) / 0.78);
    transition: color 0.2s ease;
  }
.site-nav-link:hover,
  .site-nav-link:focus-visible {
    color: #ffffff;
  }
.site-nav-link::after {
    content: "";
    position: absolute;
    left: 0.75rem;
    right: 0.75rem;
    bottom: 0.35rem;
    height: 1px;
    background: hsl(var(--accent-cyan));
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.22s ease;
    opacity: 0.85;
  }
.site-nav-link:hover::after,
  .site-nav-link:focus-visible::after,
  .site-nav-link.is-open::after {
    transform: scaleX(1);
  }
.site-nav-link.is-open {
    color: hsl(var(--accent-cyan));
  }
.site-nav-chevron {
    color: hsl(var(--ink-mute) / 0.55);
    transition: color 0.2s ease, transform 0.2s ease;
  }
.site-nav-link:hover .site-nav-chevron,
  .site-nav-link:focus-visible .site-nav-chevron,
  .site-nav-link.is-open .site-nav-chevron {
    color: hsl(var(--accent-cyan));
  }
.site-nav-dropdown {
    background: hsl(var(--bg-paper));
    border: 1px solid hsl(var(--accent-cyan) / 0.14);
    box-shadow:
      0 18px 48px rgba(0, 0, 0, 0.42),
      0 0 0 1px hsl(var(--accent-cyan) / 0.05);
  }
.site-nav-dropdown-item {
    transition: background-color 0.18s ease;
  }
.site-nav-dropdown-item:hover,
  .site-nav-dropdown-item:focus-visible {
    background: hsl(var(--accent-cyan) / 0.07);
  }
.site-nav-dropdown-item__title {
    color: hsl(var(--ink) / 0.92);
    transition: color 0.18s ease;
  }
.site-nav-dropdown-item:hover .site-nav-dropdown-item__title,
  .site-nav-dropdown-item:focus-visible .site-nav-dropdown-item__title {
    color: hsl(var(--accent-cyan));
  }
.site-nav-lang-btn {
    color: hsl(var(--ink-mute) / 0.78);
    transition: color 0.2s ease, background-color 0.2s ease;
  }
.site-nav-lang-btn:hover {
    color: #ffffff;
  }
.site-nav-mobile-link {
    color: hsl(var(--ink-mute) / 0.82);
    transition: color 0.2s ease;
  }
.site-nav-mobile-link:hover,
  .site-nav-mobile-link:focus-visible {
    color: hsl(var(--accent-cyan));
  }
.site-nav-mobile-toggle {
    color: hsl(var(--ink-mute) / 0.78);
    transition: color 0.2s ease;
  }
.site-nav-mobile-toggle:hover,
  .site-nav-mobile-toggle.is-open {
    color: hsl(var(--accent-cyan));
  }
.site-nav-mobile-sub {
    color: hsl(var(--ink-mute) / 0.78);
    transition: color 0.18s ease;
  }
.site-nav-mobile-sub:hover,
  .site-nav-mobile-sub:focus-visible {
    color: hsl(var(--accent-cyan));
  }
/* ── Hero ── */
.hero-video-wrap {
    position: absolute; inset: 0; overflow: hidden;
    background: hsl(225 35% 5%);
  }
.hero-video-wrap video {
    position: absolute; inset: 0; width: 100%; height: 100%;
    object-fit: cover;
    object-position: 58% 46%;
    filter: none;
    z-index: 0;
    backface-visibility: hidden;
    will-change: auto;
  }
/* Sol-alt banding bölgesini düz renkle kapat — chip renklerine dokunmaz */
.hero-video-scrim {
    position: absolute; inset: 0; z-index: 1;
    pointer-events: none;
    background:
      hsl(228 32% 4% / 0.36),
      linear-gradient(
        to right,
        hsl(225 35% 5% / 0.96) 0%,
        hsl(225 35% 5% / 0.72) 24%,
        hsl(225 35% 5% / 0.28) 44%,
        transparent 58%
      ),
      linear-gradient(
        to top,
        hsl(225 35% 5% / 0.82) 0%,
        hsl(225 35% 5% / 0.35) 22%,
        transparent 42%
      );
  }
.hero-video-wrap--ended .hero-video-scrim {
    background:
      hsl(228 32% 4% / 0.42),
      linear-gradient(
        to right,
        hsl(225 35% 5% / 0.98) 0%,
        hsl(225 35% 5% / 0.78) 26%,
        hsl(225 35% 5% / 0.32) 46%,
        transparent 60%
      ),
      linear-gradient(
        to top,
        hsl(225 35% 5% / 0.88) 0%,
        hsl(225 35% 5% / 0.42) 24%,
        transparent 44%
      );
  }
/* Orta metin okunabilirliği — video ile uyumlu vignette */
.hero-cinematic-scrim {
    position: absolute; inset: 0; z-index: 1;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.7s ease;
    background:
      radial-gradient(
        ellipse 85% 68% at 50% 48%,
        hsl(225 35% 5% / 0.88) 0%,
        hsl(225 35% 5% / 0.52) 40%,
        hsl(225 35% 5% / 0.18) 68%,
        transparent 82%
      );
  }
.hero-cinematic-scrim--active {
    opacity: 1;
  }
/* Sinematik hero yazıları — video altyazısı / title card hissi */
.hero-cinematic-block {
    text-shadow:
      0 0 40px rgba(0, 0, 0, 0.95),
      0 4px 24px rgba(0, 0, 0, 0.9),
      0 8px 48px rgba(0, 0, 0, 0.65);
  }
.hero-cinematic-headline{
  font-family: Outfit, sans-serif;
    font-weight: 900;
    letter-spacing: -0.01em;
    line-height: 1.12;
    font-size: clamp(1.85rem, 4.5vw, 3.25rem);
}
/* Infra AI wordmark — Infra düz beyaz, AI parlak cyan (tüm sayfa) */
.infra-ai-wordmark{
  display: inline-flex;
  align-items: baseline;
    gap: 0.22em;
    letter-spacing: -0.02em;
    line-height: 1;
}
.infra-ai-wordmark--inline {
    font-size: inherit;
    font-weight: inherit;
    font-family: inherit;
    letter-spacing: inherit;
  }
.infra-ai-wordmark--inline .hero-logo-infra {
    color: hsl(var(--ink));
    -webkit-text-fill-color: hsl(var(--ink));
    text-shadow: none;
  }
.infra-ai-wordmark--inline .hero-logo-ai {
    color: #00d4ff;
    -webkit-text-fill-color: #00d4ff;
  }
.infra-ai-wordmark--sm{
  font-family: Outfit, sans-serif;
  font-weight: 600;
    letter-spacing: -0.02em;
}
.infra-ai-wordmark--sm .hero-logo-infra {
    color: inherit;
    -webkit-text-fill-color: currentColor;
    text-shadow: none;
  }
.hero-logo-wordmark{
  font-family: Outfit, sans-serif;
  font-weight: 900;
  display: inline-flex;
  align-items: baseline;
    gap: 0.22em;
    letter-spacing: -0.02em;
    line-height: 1;
    font-size: clamp(2.25rem, 6.5vw, 4.5rem);
    filter: drop-shadow(0 2px 16px rgba(0, 0, 0, 0.65));
}
.hero-logo-infra {
    color: #ffffff;
    -webkit-text-fill-color: #ffffff;
    text-shadow:
      0 2px 16px rgba(0, 0, 0, 0.55),
      0 0 1px rgba(255, 255, 255, 0.8);
  }
.hero-logo-ai {
    color: #00d4ff;
    -webkit-text-fill-color: #00d4ff;
    text-shadow: 0 0 28px rgba(0, 212, 255, 0.5);
  }
.hero-logo-wordmark .hero-logo-ai {
    filter: drop-shadow(0 0 22px rgba(0, 212, 255, 0.4));
  }
.hero-cinematic-accent {
    color: #00d4ff;
  }
/* ── About video ── */
.about-video-wrap {
    position: relative;
    min-height: 280px;
  }
@media (min-width: 1024px) {
    .about-video-wrap {
      min-height: 360px;
    }
  }
.about-video-wrap video.about-video {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    transform: translateZ(0);
    backface-visibility: hidden;
  }
.about-video-scrim {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
    background:
      linear-gradient(to top, hsl(225 35% 5% / 0.55) 0%, transparent 38%),
      linear-gradient(to right, transparent 55%, hsl(225 35% 5% / 0.35) 100%);
  }
/* Sağ alt — video filigranını (MINIMAX / Hailuo) gizle */
.about-video-watermark-mask {
    position: absolute;
    right: 0;
    bottom: 0;
    width: min(42%, 11.5rem);
    height: min(22%, 4.25rem);
    z-index: 2;
    pointer-events: none;
    background: linear-gradient(
      145deg,
      transparent 0%,
      hsl(228 28% 6% / 0.72) 38%,
      hsl(225 35% 4% / 0.97) 68%,
      hsl(222 38% 3% / 1) 100%
    );
    box-shadow: -12px -8px 28px hsl(225 35% 4% / 0.85);
  }
.about-video-wrap--ended .about-video {
    will-change: auto;
  }
.about-video-end-wordmark {
    position: absolute;
    left: 7%;
    bottom: 6%;
    z-index: 3;
    opacity: 0;
    transform: translateY(10px);
    transition:
      opacity 0.65s cubic-bezier(0.22, 1, 0.36, 1),
      transform 0.65s cubic-bezier(0.22, 1, 0.36, 1);
    pointer-events: none;
  }
.about-video-end-wordmark.is-visible {
    opacity: 1;
    transform: translateY(0);
  }
.about-video-end-wordmark__brand {
    font-family: "Outfit", sans-serif;
    font-size: clamp(1.35rem, 3.4vw, 2.1rem);
    font-weight: 900;
    letter-spacing: -0.02em;
    line-height: 1;
    filter: drop-shadow(0 2px 18px rgba(0, 0, 0, 0.85));
  }
.about-video-end-wordmark__brand .hero-logo-infra {
    color: #ffffff;
    -webkit-text-fill-color: #ffffff;
    text-shadow:
      0 2px 14px rgba(0, 0, 0, 0.75),
      0 0 1px rgba(255, 255, 255, 0.85);
  }
.about-video-end-wordmark__brand .hero-logo-ai {
    color: #00d4ff;
    -webkit-text-fill-color: #00d4ff;
    text-shadow: 0 0 22px rgba(0, 212, 255, 0.55);
  }
.about-video-end-wordmark__tagline {
    margin: 0.5rem 0 0;
    max-width: 16rem;
    font-family: "Outfit", sans-serif;
    font-size: clamp(0.95rem, 2.15vw, 1.32rem);
    font-weight: 600;
    letter-spacing: 0.01em;
    line-height: 1.25;
    background: linear-gradient(
      90deg,
      #48cae4 0%,
      #56b8ff 18%,
      #6ea3f7 42%,
      #9b8cf8 68%,
      #c084fc 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.78));
  }
#emergent-badge { display: none !important; }
.dark .hero-engine-wrap {
    background: hsl(var(--bg-paper) / 0.65);
  }
/* ── Marquee / Logo band ── */
.marquee-track {
    display: flex;
    gap: 0;
    animation: marquee 32s linear infinite;
    width: max-content;
  }
.marquee-track:hover { animation-play-state: paused; }
/* ── Scroll reveal ── */
.reveal {
    opacity: 0;
    transform: translateY(40px) scale(0.98);
    filter: blur(5px);
    transition:
      opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1),
      transform 0.8s cubic-bezier(0.22, 1, 0.36, 1),
      filter 0.65s cubic-bezier(0.22, 1, 0.36, 1);
    will-change: opacity, transform;
  }
.reveal.revealed {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
    will-change: auto;
  }
.reveal-left {
    opacity: 0;
    transform: translateX(-40px);
    filter: blur(4px);
    transition:
      opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1),
      transform 0.8s cubic-bezier(0.22, 1, 0.36, 1),
      filter 0.65s cubic-bezier(0.22, 1, 0.36, 1);
  }
.reveal-right {
    opacity: 0;
    transform: translateX(40px);
    filter: blur(4px);
    transition:
      opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1),
      transform 0.8s cubic-bezier(0.22, 1, 0.36, 1),
      filter 0.65s cubic-bezier(0.22, 1, 0.36, 1);
  }
.reveal-left.revealed,
  .reveal-right.revealed {
    opacity: 1;
    transform: translateX(0);
    filter: blur(0);
  }
/* stagger — kartlar sırayla (JS delay + CSS yedek) */
.stagger > *:nth-child(1) { transition-delay: 0ms; }
.stagger > *:nth-child(2) { transition-delay: 90ms; }
.stagger > *:nth-child(3) { transition-delay: 180ms; }
.stagger > *:nth-child(4) { transition-delay: 270ms; }
.stagger > *:nth-child(5) { transition-delay: 360ms; }
.stagger > *:nth-child(6) { transition-delay: 450ms; }
.stagger > *:nth-child(7) { transition-delay: 540ms; }
.stagger > *:nth-child(8) { transition-delay: 630ms; }
.stagger > *:nth-child(9) { transition-delay: 720ms; }
.stagger > *:nth-child(10) { transition-delay: 810ms; }
.stagger > *:nth-child(11) { transition-delay: 900ms; }
.stagger > *:nth-child(12) { transition-delay: 990ms; }
/* ── Premium card ── */
.card-premium {
    position: relative;
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
.card-premium::before {
    content: "";
    position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(0,212,255,0.06) 0%, rgba(155,89,245,0.04) 45%, transparent 70%);
    pointer-events: none;
    opacity: 0.55;
    transition: opacity 0.3s ease;
  }
.card-premium:hover::before { opacity: 1; }
.card-premium:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,212,255,0.1);
  }
/* ── Metrics count ── */
.count-cell { font-variant-numeric: tabular-nums; }
/* ── Separator line ── */
/* ── Why InfraAI ── */
.why-infraai {
    background: hsl(var(--bg));
    position: relative;
  }
.why-infraai::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);
    background-size: 56px 56px;
    mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 0%, transparent 75%);
    pointer-events: none;
  }
.why-infraai-glow {
    position: absolute;
    top: -120px;
    left: 50%;
    transform: translateX(-50%);
    width: 680px;
    height: 420px;
    background: radial-gradient(circle, rgba(0, 212, 255, 0.10), transparent 70%);
    filter: blur(40px);
    pointer-events: none;
  }
.why-eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    margin-bottom: 22px;
    font-family: "JetBrains Mono", monospace;
    font-size: 11px;
    letter-spacing: 0.28em;
    text-transform: uppercase;
    color: #00d4ff;
    font-weight: 600;
  }
.why-eyebrow-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #00d4ff;
    box-shadow: 0 0 12px #00d4ff;
    animation: why-pulse 2.4s ease-in-out infinite;
  }
.why-chain {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border: 1px solid hsl(var(--line));
    border-radius: 14px;
    overflow: hidden;
    background: linear-gradient(180deg, rgba(18, 24, 38, 0.9), rgba(10, 14, 24, 0.9));
  }
.why-chain-step {
    position: relative;
    padding: 26px 22px 30px;
    border-right: 1px solid #1e2535;
    transition:
      opacity 0.5s ease,
      background 0.5s ease,
      box-shadow 0.5s ease,
      transform 0.5s ease;
  }
.why-chain-step:not(.why-chain-step--active) {
    opacity: 0.48;
  }
.why-chain-step--active {
    opacity: 1;
    z-index: 1;
    transform: translateY(-2px);
  }
.why-chain-step--active.why-chain-step--nai {
    background: rgba(0, 212, 255, 0.09);
    box-shadow:
      inset 0 3px 0 #00d4ff,
      0 0 32px rgba(0, 212, 255, 0.14);
  }
.why-chain-step--active.why-chain-step--rival {
    background: rgba(245, 158, 11, 0.12);
    box-shadow:
      inset 0 3px 0 #f59e0b,
      0 0 32px rgba(245, 158, 11, 0.16);
  }
.why-chain-step--active.why-chain-step--rival .why-chain-verb {
    color: #fbbf24;
  }
.why-chain-step--active.why-chain-step--rival .font-mono {
    color: #f59e0b;
    opacity: 1;
  }
.why-chain-step--active.why-chain-step--nai .font-mono {
    opacity: 1;
  }
.why-chain-step:last-child { border-right: 0; }
.why-chain-step--rival {
    background: rgba(245, 158, 11, 0.04);
    border-right: 1px dashed rgba(245, 158, 11, 0.55);
    padding-bottom: 58px;
  }
.why-chain-step--rival .why-chain-verb { color: hsl(var(--ink-mute)); }
.why-chain-step--rival .font-mono { color: hsl(var(--ink-dim)); }
.why-chain-step--nai .why-chain-verb { color: #00d4ff; }
.why-chain-step--nai .font-mono { color: #00d4ff; opacity: 0.65; }
.why-chain-verb {
    font-family: "Outfit", sans-serif;
    font-weight: 700;
    font-size: 21px;
    letter-spacing: -0.01em;
    margin-bottom: 7px;
  }
.why-rival-label {
    position: absolute;
    bottom: 14px;
    left: 14px;
    right: 14px;
    display: block;
    text-align: center;
    font-family: "JetBrains Mono", monospace;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.06em;
    line-height: 1.35;
    text-transform: uppercase;
    color: #fbbf24;
    padding: 7px 10px;
    border: 1px solid rgba(245, 158, 11, 0.65);
    border-radius: 6px;
    background: rgba(245, 158, 11, 0.14);
    box-shadow:
      0 0 20px rgba(245, 158, 11, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.06);
  }
.why-flowline {
    height: 2px;
    border-radius: 2px;
    background: linear-gradient(
      90deg,
      transparent 0%, transparent 25%,
      #00d4ff 35%, #9b59f5 75%, transparent 100%
    );
    background-size: 200% 100%;
    animation: why-flow 3.2s linear infinite;
    opacity: 0.8;
  }
.why-pillars {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
.why-pillar {
    position: relative;
    display: grid;
    grid-template-rows: auto auto 1fr auto;
    background: hsl(var(--bg-paper));
    border: 1px solid hsl(var(--line));
    border-radius: 13px;
    padding: 24px 22px 22px;
    overflow: hidden;
    transition: transform 0.3s ease, border-color 0.3s ease;
  }
.why-pillar::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(150deg, rgba(0, 212, 255, 0.07), transparent 55%);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
.why-pillar:hover {
    transform: translateY(-4px);
    border-color: rgba(0, 212, 255, 0.35);
  }
.why-pillar:hover::before { opacity: 1; }
.why-pillar-icon {
    width: 4.5rem;
    height: 4.5rem;
    margin-bottom: 18px;
    background: transparent;
    border: none;
    border-radius: 0;
  }
.neon-icon-wrap {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
  }
.neon-icon-wrap img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    object-position: left bottom;
    display: block;
  }
.why-pillar-body {
    align-self: start;
  }
.why-term {
    padding-top: 14px;
  }
.why-term-box {
    font-family: "JetBrains Mono", monospace;
    font-size: 11px;
    background: #060912;
    border: 1px solid hsl(var(--line));
    border-radius: 7px;
    padding: 9px 11px;
    color: hsl(var(--ink-mute));
    line-height: 1.65;
    min-height: 4.95em;
  }
.why-t-cyan   { color: #00d4ff; }
.why-t-amber  { color: #f59e0b; }
.why-t-violet { color: #9b59f5; }
.why-t-green  { color: #4ade80; }
.why-t-red    { color: #f87171; }
.why-t-dim    { color: hsl(var(--ink-dim)); }
.why-t-arrow  { color: #00d4ff; }
.why-stat-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 10px 18px;
  }
.why-stat-div {
    width: 1px;
    height: 18px;
    background: hsl(var(--line));
  }
@media (max-width: 860px) {
    .why-chain { grid-template-columns: repeat(2, 1fr); }
    .why-chain-step:nth-child(2) { border-right: 0; }
    .why-chain-step--rival {
      padding-bottom: 26px;
    }
    .why-rival-label {
      position: static;
      display: block;
      margin-top: 12px;
    }
    .why-pillars { grid-template-columns: repeat(2, 1fr); }
  }
@media (max-width: 520px) {
    .why-chain,
    .why-pillars { grid-template-columns: 1fr; }
    .why-chain-step {
      border-right: 0;
      border-bottom: 1px solid #1e2535;
    }
    .why-chain-step--rival {
      border-right: 0;
      border-bottom: 1px dashed rgba(245, 158, 11, 0.5);
    }
  }
@media (prefers-reduced-motion: reduce) {
    .why-flowline,
    .why-eyebrow-dot { animation: none; }
  }
/* ── Capabilities ── */
.capabilities {
    background: hsl(var(--bg));
    position: relative;
  }
.capabilities-hero-grid {
    min-height: 280px;
  }
@media (min-width: 1024px) {
    .capabilities-hero-grid {
      min-height: 320px;
    }
  }
.capabilities-hero-card {
    min-height: 280px;
    background: hsl(var(--bg-paper));
    border: 1px solid hsl(var(--line) / 0.65);
    border-radius: 14px;
    padding: 28px 24px;
    box-shadow: 0 0 80px rgba(0, 212, 255, 0.06);
  }
@media (min-width: 768px) {
    .capabilities-hero-card {
      padding: 32px 28px;
    }
  }
@media (min-width: 1024px) {
    .capabilities-hero-card {
      min-height: 320px;
      padding: 36px 32px;
    }
  }
.capabilities-hero-card--media {
    padding: 0;
    overflow: hidden;
  }
.capabilities-hero-card--media .about-video-wrap {
    min-height: 280px;
    border-radius: inherit;
  }
@media (min-width: 1024px) {
  .capabilities-hero-card--media .about-video-wrap {
    min-height: 320px;
    }
  }
/* Sol metin kartı — çerçevede dönen beyaz ışık huzmesi */
.capabilities-hero-card--border-beam {
    position: relative;
    isolation: isolate;
    overflow: hidden;
    border-color: transparent;
  }
.capabilities-hero-card--border-beam::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 220%;
    aspect-ratio: 1;
    transform: translate(-50%, -50%) rotate(0deg);
    opacity: 0;
    background: conic-gradient(
      from 0deg,
      transparent 0deg 318deg,
      rgba(255, 255, 255, 0.18) 326deg,
      rgba(255, 255, 255, 0.85) 336deg,
      rgba(255, 255, 255, 1) 343deg,
      rgba(255, 255, 255, 0.85) 350deg,
      rgba(255, 255, 255, 0.18) 358deg,
      transparent 360deg
    );
    animation: none;
    z-index: 0;
    pointer-events: none;
  }
.capabilities-hero-card--border-beam.revealed {
    animation: capabilities-border-beam-card-settle 5.4s linear 1 forwards;
  }
@keyframes capabilities-border-beam-card-settle {
    0%,
    92% {
      border-color: transparent;
    }
    100% {
      border-color: hsl(var(--line) / 0.65);
    }
  }
.capabilities-hero-card--border-beam.revealed::before {
    opacity: 1;
    animation: capabilities-border-beam-spin 5s linear 0.4s 1 forwards;
  }
.capabilities-hero-card--border-beam::after {
    content: "";
    position: absolute;
    inset: 1.5px;
    border-radius: 12.5px;
    background: hsl(var(--bg-paper));
    z-index: 0;
    pointer-events: none;
  }
.capabilities-hero-card--border-beam > * {
    position: relative;
    z-index: 1;
  }
@keyframes capabilities-border-beam-spin {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
      opacity: 1;
    }
    92% {
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
      opacity: 0;
    }
  }
@media (prefers-reduced-motion: reduce) {
    .capabilities-hero-card--border-beam::before {
      animation: none;
      opacity: 0;
    }
    .capabilities-hero-card--border-beam,
    .capabilities-hero-card--border-beam.revealed {
      animation: none;
      border-color: hsl(var(--line) / 0.65);
    }
  }
.capabilities-cards-title {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.1em;
    font-family: "Outfit", sans-serif;
    font-size: clamp(1.625rem, 3.2vw, 2.125rem);
    font-weight: 700;
    letter-spacing: -0.02em;
    color: hsl(var(--ink));
  }
.capabilities-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    align-items: stretch;
  }
@media (min-width: 768px) {
    .capabilities-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
@media (min-width: 1280px) {
    .capabilities-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
.capability-card {
    position: relative;
    display: grid;
    grid-template-rows: auto auto auto 1fr;
    height: 100%;
    min-height: 100%;
    background: hsl(var(--bg-paper));
    border: 1px solid hsl(var(--line));
    border-radius: 14px;
    padding: 26px 24px 24px;
    overflow: hidden;
    transition: transform 0.3s ease, border-color 0.3s ease;
  }
.capability-card::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(155deg, rgba(0, 212, 255, 0.05), transparent 58%);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
.capability-card:hover {
    transform: translateY(-3px);
    border-color: rgba(0, 212, 255, 0.28);
  }
.capability-card:hover::before { opacity: 1; }
.capability-badge {
    display: inline-block;
    margin-bottom: 18px;
    font-family: "JetBrains Mono", monospace;
    font-size: 9.5px;
    font-weight: 700;
    letter-spacing: 0.16em;
    padding: 5px 9px;
    border-radius: 5px;
  }
.capability-icon {
    width: 4.5rem;
    height: 4.5rem;
    margin-bottom: 16px;
    background: transparent;
    border: none;
    border-radius: 0;
  }
.capability-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 11px;
  }
.capability-list li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 13.5px;
    line-height: 1.55;
    color: hsl(var(--ink-mute));
  }
.capability-check {
    flex-shrink: 0;
    margin-top: 2px;
    font-family: "JetBrains Mono", monospace;
    font-size: 11px;
    font-weight: 700;
    color: #4ade80;
  }
.partner-logo-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1px;
    background: hsl(var(--line));
  }
@media (min-width: 640px) {
    .partner-logo-grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }
@media (min-width: 768px) {
    .partner-logo-grid {
      grid-template-columns: repeat(6, 1fr);
    }
  }
.partner-logo-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 72px;
    padding: 20px 16px;
    transition: background 0.2s ease;
  }
.partner-logo-cell:hover {
    background: hsl(var(--bg-surface));
  }
.partner-logo-img {
    width: auto;
    height: 28px;
    max-width: 100%;
    object-fit: contain;
    opacity: 0.55;
    filter: grayscale(1) brightness(0);
    transition: opacity 0.2s ease;
  }
.dark .partner-logo-img {
    filter: grayscale(1) brightness(0) invert(1);
  }
.partner-logo-cell:hover .partner-logo-img {
    opacity: 0.85;
  }
.nav-dropdown-desc {
    color: hsl(var(--ink-mute) / 0.92);
    font-weight: 500;
    line-height: 1.45;
  }
.form-trust-band {
    list-style: none;
    padding: 0;
    margin: 0;
  }
.form-trust-band__item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    font-size: 14px;
    line-height: 1.55;
    color: hsl(var(--ink-mute));
  }
.form-trust-band__check {
    flex-shrink: 0;
    margin-top: 2px;
    font-size: 13px;
    font-weight: 700;
    color: hsl(var(--accent-cyan));
  }
.about-stat-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 108px;
  }
.partners-footer-quote {
    margin: 0;
    padding: 14px 24px 16px;
    border-top: 1px solid hsl(var(--line));
    font-family: "JetBrains Mono", monospace;
    font-size: 10.5px;
    letter-spacing: 0.03em;
    line-height: 1.65;
    color: hsl(var(--ink-dim));
    text-align: center;
  }
/* ── Use Cases (legacy card styles kept for reuse) ── */
.use-cases-glow {
    position: absolute;
    top: -80px;
    right: -120px;
    width: 520px;
    height: 360px;
    background: radial-gradient(circle, rgba(0, 212, 255, 0.08), transparent 70%);
    filter: blur(40px);
    pointer-events: none;
  }

/* ── Keyframes ── */
@keyframes pulse-glow {
  0%, 100% { opacity: 0.4; }
  50%       { opacity: 1; }
}
@keyframes flow {
  0%   { stroke-dashoffset: 200; }
  100% { stroke-dashoffset: 0; }
}
@keyframes fade-up {
  0%   { opacity: 0; transform: translateY(16px); }
  100% { opacity: 1; transform: translateY(0); }
}
@keyframes marquee {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
@keyframes count-up-in {
  from { opacity: 0; transform: translateY(20px) scale(0.92); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes shimmer {
  0%   { background-position: -200% center; }
  100% { background-position: 200% center; }
}
@keyframes why-flow {
  0%   { background-position: 150% 0; }
  100% { background-position: -50% 0; }
}
@keyframes why-pulse {
  0%, 100% { opacity: 0.4; }
  50%       { opacity: 1; }
}

.animate-pulse-glow { animation: pulse-glow 2.5s ease-in-out infinite; }
.animate-fade-up    { animation: fade-up 0.6s ease-out forwards; }
.animate-count-in   { animation: count-up-in 0.5s ease-out forwards; }
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.first\\:border-l:first-child{
  border-left-width: 1px;
}
.last\\:rounded-r-md:last-child{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.last\\:border-r-0:last-child{
  border-right-width: 0px;
}
.focus-within\\:relative:focus-within{
  position: relative;
}
.focus-within\\:z-20:focus-within{
  z-index: 20;
}
.hover\\:border-amber:hover{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.hover\\:border-cyan:hover{
  --tw-border-opacity: 1;
  border-color: rgb(0 212 255 / var(--tw-border-opacity, 1));
}
.hover\\:border-line\\/80:hover{
  border-color: hsl(var(--line) / 0.8);
}
.hover\\:border-red-400\\/60:hover{
  border-color: rgb(248 113 113 / 0.6);
}
.hover\\:bg-bg-paper\\/60:hover{
  background-color: hsl(var(--bg-paper) / 0.6);
}
.hover\\:bg-bg-surface:hover{
  --tw-bg-opacity: 1;
  background-color: hsl(var(--bg-surface) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-light:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 221 255 / var(--tw-bg-opacity, 1));
}
.hover\\:text-cyan:hover{
  --tw-text-opacity: 1;
  color: rgb(0 212 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-ink:hover{
  --tw-text-opacity: 1;
  color: hsl(var(--ink) / var(--tw-text-opacity, 1));
}
.hover\\:text-red-400:hover{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.focus\\:border-cyan:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 212 255 / var(--tw-border-opacity, 1));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.group:hover .group-hover\\:w-full{
  width: 100%;
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:opacity-30{
  opacity: 0.3;
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}
.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (min-width: 640px){

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-lg{
    border-radius: 0.5rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-right{
    text-align: right;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:inline-flex{
    display: inline-flex;
  }

  .md\\:h-40{
    height: 10rem;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:p-10{
    padding: 2.5rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .md\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:\\!pt-20{
    padding-top: 5rem !important;
  }

  .md\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-\\[1\\.35rem\\]{
    font-size: 1.35rem;
  }

  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px){

  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .lg\\:inline{
    display: inline;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:min-h-\\[360px\\]{
    min-height: 360px;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:gap-14{
    gap: 3.5rem;
  }

  .lg\\:gap-8{
    gap: 2rem;
  }
}
@media (min-width: 1280px){

  .xl\\:gap-16{
    gap: 4rem;
  }

  .xl\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .xl\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: 0.375rem;
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,sCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;IAAA,6DAAc;IAAd,0BAAc,KAAd,YAAc;IAAd,2BAAc,IAAd,YAAc;IAAd,2BAAc,IAAd,YAAc;IAAd,2BAAc,IAAd,YAAc;IAAd,2BAAc,IAAd,YAAc;IAAd,2BAAc,IAAd,YAAc;IAAd,2BAAc,IAAd,YAAc;IAAd,2BAAc;IAAd,4BAAc,GAAd,YAAc;IAAd,0BAAc,KAAd,YAAc;IAAd,2BAAc,IAAd,YAAc;IAAd,kCAAc;IAAd,gCAAc;IAAd,iCAAc;IAAd,qBAAc;IAAd,mBAAc;IAAd,0BAAc;IAAd,2BAAc,IAAd,oBAAc;IAAd,2BAAc,IAAd,cAAc;IAAd,2BAAc,IAAd,sBAAc;EAAA;;AAAd;IAAA,2BAAc;IAAd,2BAAc;IAAd,2BAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,2BAAc;IAAd,2BAAc;IAAd,2BAAc;IAAd,2BAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,gCAAc;IAAd,iCAAc;IAAd,qBAAc;IAAd,oBAAc;IAAd,2BAAc;IAAd,2BAAc;IAAd,2BAAc;IAAd,2BAAc;EAAA;;AAAd,OAAA,uBAAc,EAAA;;AAAd;EAAA,kBAAc;EAAd,0DAAc;EAAd,8BAAc;EAAd,oBAAc;EAAd,kDAAc;EAAd,mCAAc;EAAd,kCAAc;IAAd;AAAc;;AAAd;EAAA,+BAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd,cAAA,qBAAc,EAAd,cAAc,EAAA;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA6DF;EAAA,iBAAsC;EAAtC,kBAAsC;EAAtC,gBAAsC;EAAtC,oBAAsC;EAAtC;AAAsC;AAAtC;;EAAA;IAAA,kBAAsC;IAAtC;EAAsC;AAAA;AAGnD;EAAA,sCAAqE;EAArE,eAAqE;EAArE,gBAAqE;EAArE,yBAAqE;EAArE;AAAqE;AAArE;IAAA,cAAqE;IAArE,UAAqE;EAAA;AAArE;IAAA,UAAqE;EAAA;AAArE,wCAAA,0BAAqE,EAAA;AAArE,sCAAA,cAAqE,EAArE,aAAqE,EAAA;AADvE;IAEE,8BAA8B;EAChC;AAEA,yBAAyB;AACzB;IACE;;wEAEoE;IACpE,0BAA0B;EAC5B;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,wBAAwB;IACxB,uBAAuB;IACvB,yDAAuQ;EACzQ;AACA;IACE,+EAA+E;IAC/E,0BAA0B;EAC5B;AAEA,eAAe;AACf;IACE,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;EAC7B;AACA,eAAe,yEAAyE,EAAE;AAC1F,eAAe,2EAA2E,EAAE;AAC5F,eAAe,0EAA0E,EAAE;AAE3F,eAAe;AACf,eAAe,qBAAqB,EAAE,kCAAkC,EAAE;AAE1E,wBAAwB;AAUxB,4BAA4B;AAC5B,sBAAsB,8BAA8B,EAAE;AACtD,sBAAsB,+BAA+B,EAAE;AAGvD,qDAAqD;AACrD;IACE,kBAAkB;IAClB,kCAAkC;IAClC,2BAA2B;EAC7B;AACA;;IAEE,cAAc;EAChB;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,WAAW;IACX,mCAAmC;IACnC,oBAAoB;IACpB,wBAAwB;IACxB,gCAAgC;IAChC,aAAa;EACf;AACA;;;IAGE,oBAAoB;EACtB;AACA;IACE,8BAA8B;EAChC;AACA;IACE,kCAAkC;IAClC,gDAAgD;EAClD;AACA;;;IAGE,8BAA8B;EAChC;AACA;IACE,gCAAgC;IAChC,gDAAgD;IAChD;;8CAE0C;EAC5C;AACA;IACE,uCAAuC;EACzC;AACA;;IAEE,0CAA0C;EAC5C;AACA;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACA;;IAEE,8BAA8B;EAChC;AACA;IACE,kCAAkC;IAClC,uDAAuD;EACzD;AACA;IACE,cAAc;EAChB;AACA;IACE,kCAAkC;IAClC,2BAA2B;EAC7B;AACA;;IAEE,8BAA8B;EAChC;AACA;IACE,kCAAkC;IAClC,2BAA2B;EAC7B;AACA;;IAEE,8BAA8B;EAChC;AACA;IACE,kCAAkC;IAClC,4BAA4B;EAC9B;AACA;;IAEE,8BAA8B;EAChC;AAEA,eAAe;AACf;IACE,kBAAkB,EAAE,QAAQ,EAAE,gBAAgB;IAC9C,2BAA2B;EAC7B;AACA;IACE,kBAAkB,EAAE,QAAQ,EAAE,WAAW,EAAE,YAAY;IACvD,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,UAAU;IACV,2BAA2B;IAC3B,iBAAiB;EACnB;AACA,0EAA0E;AAC1E;IACE,kBAAkB,EAAE,QAAQ,EAAE,UAAU;IACxC,oBAAoB;IACpB;;;;;;;;;;;;;;OAcG;EACL;AACA;IACE;;;;;;;;;;;;;;OAcG;EACL;AACA,0DAA0D;AAC1D;IACE,kBAAkB,EAAE,QAAQ,EAAE,UAAU;IACxC,oBAAoB;IACpB,UAAU;IACV,6BAA6B;IAC7B;;;;;;;OAOG;EACL;AACA;IACE,UAAU;EACZ;AACA,iEAAiE;AACjE;IACE;;;oCAGgC;EAClC;AAEE;EAAA,+BAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB;AAJmB;AAkCrB,oEAAoE;AAElE;EAAA,oBAAiC;EAAjC,qBAAiC;IACjC,WAAW;IACX,uBAAuB;IACvB;AAHiC;AAKnC;IACE,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;EACzB;AACA;IACE,sBAAsB;IACtB,wCAAwC;IACxC,iBAAiB;EACnB;AACA;IACE,cAAc;IACd,gCAAgC;EAClC;AAEE;EAAA,+BAAiC;EAAjC,gBAAiC;IACjC;AADiC;AAGnC;IACE,cAAc;IACd,qCAAqC;IACrC,iBAAiB;EACnB;AAEE;EAAA,+BAAgD;EAAhD,gBAAgD;EAAhD,oBAAgD;EAAhD,qBAAgD;IAAhD,WAAgD;IAAhD,uBAAgD;IAAhD,cAAgD;IAChD,wCAAwC;IACxC;AAFgD;AAIlD;IACE,cAAc;IACd,gCAAgC;IAChC;;sCAEkC;EACpC;AACA;IACE,cAAc;IACd,gCAAgC;IAChC,4CAA4C;EAC9C;AACA;IACE,oDAAoD;EACtD;AACA;IACE,cAAc;EAChB;AAOA,sBAAsB;AACtB;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACA;IACE;MACE,iBAAiB;IACnB;EACF;AACA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;IAC9B,wBAAwB;IACxB,2BAA2B;EAC7B;AACA;IACE,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,UAAU;IACV;;6EAEyE;EAC3E;AACA,yDAAyD;AACzD;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wBAAwB;IACxB,yBAAyB;IACzB,UAAU;IACV,oBAAoB;IACpB;;;;;;KAMC;IACD,kDAAkD;EACpD;AACA;IACE,iBAAiB;EACnB;AACA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,UAAU;IACV,2BAA2B;IAC3B;;oDAEgD;IAChD,oBAAoB;EACtB;AACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACA;IACE,iCAAiC;IACjC,wCAAwC;IACxC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,mDAAmD;EACrD;AACA;IACE,cAAc;IACd,gCAAgC;IAChC;;uCAEmC;EACrC;AACA;IACE,cAAc;IACd,gCAAgC;IAChC,6CAA6C;EAC/C;AACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,0CAA0C;IAC1C,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB;;;;;;;KAOC;IACD,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,oCAAoC;IACpC,mDAAmD;EACrD;AAEA,kBAAkB,wBAAwB,EAAE;AAQ5C;IACE,uCAAuC;EACzC;AAEA,8BAA8B;AAC9B;IACE,aAAa;IACb,MAAM;IACN,sCAAsC;IACtC,kBAAkB;EACpB;AACA,uBAAuB,4BAA4B,EAAE;AAErD,wBAAwB;AACxB;IACE,UAAU;IACV,uCAAuC;IACvC,iBAAiB;IACjB;;;iDAG6C;IAC7C,+BAA+B;EACjC;AACA;IACE,UAAU;IACV,iCAAiC;IACjC,eAAe;IACf,iBAAiB;EACnB;AACA;IACE,UAAU;IACV,4BAA4B;IAC5B,iBAAiB;IACjB;;;iDAG6C;EAC/C;AACA;IACE,UAAU;IACV,2BAA2B;IAC3B,iBAAiB;IACjB;;;iDAG6C;EAC/C;AACA;;IAEE,UAAU;IACV,wBAAwB;IACxB,eAAe;EACjB;AAEA,qDAAqD;AACrD,4BAA4B,qBAAqB,EAAE;AACnD,4BAA4B,sBAAsB,EAAE;AACpD,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,uBAAuB,EAAE;AACrD,6BAA6B,uBAAuB,EAAE;AACtD,6BAA6B,uBAAuB,EAAE;AACtD,6BAA6B,uBAAuB,EAAE;AAEtD,uBAAuB;AACvB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,qDAAqD;EACvD;AACA;IACE,WAAW;IACX,kBAAkB,EAAE,QAAQ;IAC5B,wGAAwG;IACxG,oBAAoB;IACpB,aAAa;IACb,6BAA6B;EAC/B;AACA,8BAA8B,UAAU,EAAE;AAC1C;IACE,2BAA2B;IAC3B,uEAAuE;EACzE;AAEA,wBAAwB;AACxB,cAAc,kCAAkC,EAAE;AAElD,yBAAyB;AAMzB,sBAAsB;AACtB;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;6EAEyE;IACzE,0BAA0B;IAC1B,iFAAiF;IACjF,oBAAoB;EACtB;AACA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,6EAA6E;IAC7E,kBAAkB;IAClB,oBAAoB;EACtB;AACA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;EAClB;AACA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;IAC5B,8CAA8C;EAChD;AACA;IACE,aAAa;IACb,qCAAqC;IACrC,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,iFAAiF;EACnF;AACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;IAC/B;;;;yBAIqB;EACvB;AACA;IACE,aAAa;EACf;AACA;IACE,UAAU;IACV,UAAU;IACV,2BAA2B;EAC7B;AACA;IACE,mCAAmC;IACnC;;sCAEkC;EACpC;AACA;IACE,oCAAoC;IACpC;;uCAEmC;EACrC;AACA;IACE,cAAc;EAChB;AACA;IACE,cAAc;IACd,UAAU;EACZ;AACA;IACE,UAAU;EACZ;AACA,6BAA6B,eAAe,EAAE;AAC9C;IACE,oCAAoC;IACpC,iDAAiD;IACjD,oBAAoB;EACtB;AACA,yCAAyC,2BAA2B,EAAE;AACtE,oCAAoC,0BAA0B,EAAE;AAChE,uCAAuC,cAAc,EAAE;AACvD,kCAAkC,cAAc,EAAE,aAAa,EAAE;AACjE;IACE,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;EACpB;AACA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,0CAA0C;IAC1C,kBAAkB;IAClB,oCAAoC;IACpC;;6CAEyC;EAC3C;AACA;IACE,WAAW;IACX,kBAAkB;IAClB;;;;KAIC;IACD,0BAA0B;IAC1B,wCAAwC;IACxC,YAAY;EACd;AACA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;AACA;IACE,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,gCAAgC;IAChC,kCAAkC;IAClC,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,uDAAuD;EACzD;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,6EAA6E;IAC7E,UAAU;IACV,6BAA6B;IAC7B,oBAAoB;EACtB;AACA;IACE,2BAA2B;IAC3B,qCAAqC;EACvC;AACA,4BAA4B,UAAU,EAAE;AACxC;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;AACA;IACE,aAAa;IACb,qBAAqB;IACrB,2BAA2B;EAC7B;AACA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,4BAA4B;IAC5B,cAAc;EAChB;AACA;IACE,iBAAiB;EACnB;AACA;IACE,iBAAiB;EACnB;AACA;IACE,wCAAwC;IACxC,eAAe;IACf,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;EACpB;AACA,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,cAAc,EAAE;AAChC;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;EAChB;AACA;IACE,UAAU;IACV,YAAY;IACZ,4BAA4B;EAC9B;AACA;IACE,aAAa,qCAAqC,EAAE;IACpD,+BAA+B,eAAe,EAAE;IAChD;MACE,oBAAoB;IACtB;IACA;MACE,gBAAgB;MAChB,cAAc;MACd,gBAAgB;IAClB;IACA,eAAe,qCAAqC,EAAE;EACxD;AACA;IACE;mBACe,0BAA0B,EAAE;IAC3C;MACE,eAAe;MACf,gCAAgC;IAClC;IACA;MACE,eAAe;MACf,iDAAiD;IACnD;EACF;AACA;IACE;uBACmB,eAAe,EAAE;EACtC;AAEA,uBAAuB;AACvB;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;AAwBA;IACE,iBAAiB;EACnB;AACA;IACE;MACE,iBAAiB;IACnB;EACF;AACA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;EAC9C;AACA;IACE;MACE,kBAAkB;IACpB;EACF;AACA;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;EACF;AACA;IACE,UAAU;IACV,gBAAgB;EAClB;AACA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACA;EACA;IACE,iBAAiB;IACjB;EACF;AACA,yDAAyD;AACzD;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,eAAe;IACf,6CAA6C;IAC7C,UAAU;IACV;;;;;;;;;KASC;IACD,eAAe;IACf,UAAU;IACV,oBAAoB;EACtB;AACA;IACE,sEAAsE;EACxE;AACA;IACE;;MAEE,yBAAyB;IAC3B;IACA;MACE,qCAAqC;IACvC;EACF;AACA;IACE,UAAU;IACV,kEAAkE;EACpE;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,gCAAgC;IAChC,UAAU;IACV,oBAAoB;EACtB;AACA;IACE,kBAAkB;IAClB,UAAU;EACZ;AACA;IACE;MACE,6CAA6C;MAC7C,UAAU;IACZ;IACA;MACE,UAAU;IACZ;IACA;MACE,+CAA+C;MAC/C,UAAU;IACZ;EACF;AACA;IACE;MACE,eAAe;MACf,UAAU;IACZ;IACA;;MAEE,eAAe;MACf,qCAAqC;IACvC;EACF;AACA;IACE,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,iCAAiC;IACjC,2CAA2C;IAC3C,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;EACxB;AACA;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,oBAAoB;EACtB;AACA;IACE;MACE,qCAAqC;IACvC;EACF;AACA;IACE;MACE,qCAAqC;IACvC;EACF;AACA;IACE,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,kCAAkC;IAClC,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,uDAAuD;EACzD;AACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,6EAA6E;IAC7E,UAAU;IACV,6BAA6B;IAC7B,oBAAoB;EACtB;AACA;IACE,2BAA2B;IAC3B,qCAAqC;EACvC;AACA,iCAAiC,UAAU,EAAE;AAC7C;IACE,qBAAqB;IACrB,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;EACpB;AAgBA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;AACA;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;AACA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;EAC7B;AACA;IACE,cAAc;IACd,eAAe;IACf,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;AACA;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,4BAA4B;EAC9B;AACA;IACE;MACE,qCAAqC;IACvC;EACF;AACA;IACE;MACE,qCAAqC;IACvC;EACF;AACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;EAClC;AACA;IACE,kCAAkC;EACpC;AACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,6BAA6B;EAC/B;AACA;IACE,4CAA4C;EAC9C;AACA;IACE,aAAa;EACf;AACA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;EACnB;AAIA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;AACA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,2BAA2B;EAC7B;AACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,8BAA8B;EAChC;AACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;EACnB;AACA;IACE,SAAS;IACT,uBAAuB;IACvB,sCAAsC;IACtC,wCAAwC;IACxC,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;EACpB;AAEA,wDAAwD;AAKxD;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,YAAY;IACZ,aAAa;IACb,6EAA6E;IAC7E,kBAAkB;IAClB,oBAAoB;EACtB;;AAyEF,oBAAoB;AACpB;EACE,WAAW,YAAY,EAAE;EACzB,YAAY,UAAU,EAAE;AAC1B;AACA;EACE,OAAO,sBAAsB,EAAE;EAC/B,OAAO,oBAAoB,EAAE;AAC/B;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,2BAA2B,EAAE;AACtC;AACA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,OAAO,iCAAiC,EAAE;EAC1C,OAAO,gCAAgC,EAAE;AAC3C;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,2BAA2B,EAAE;AACtC;AACA;EACE,WAAW,YAAY,EAAE;EACzB,YAAY,UAAU,EAAE;AAC1B;;AAEA,sBAAsB,+CAA+C,EAAE;AACvE,sBAAsB,yCAAyC,EAAE;AACjE,sBAAsB,6CAA6C,EAAE;AA/zCrE;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,mBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA,QAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA,sBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,gCAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,iCAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,sBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,sBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,kBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,kBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,sBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,8BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,2GAg0CA;EAh0CA,yGAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,2GAg0CA;EAh0CA,yGAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,8BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,2GAg0CA;EAh0CA,yGAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,2GAg0CA;EAh0CA,yGAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,+EAg0CA;EAh0CA,mGAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,yBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,yBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,sBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,qBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,qBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,gDAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,iDAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,0EAg0CA;EAh0CA,8FAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,qBAg0CA;EAh0CA,yBAg0CA;EAh0CA,2BAg0CA;EAh0CA,yBAg0CA;EAh0CA,0BAg0CA;EAh0CA,+BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,qBAg0CA;EAh0CA,yBAg0CA;EAh0CA,2BAg0CA;EAh0CA,yBAg0CA;EAh0CA,0BAg0CA;EAh0CA,+BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,qBAg0CA;EAh0CA,yBAg0CA;EAh0CA,2BAg0CA;EAh0CA,yBAg0CA;EAh0CA,0BAg0CA;EAh0CA,+BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA,yBAg0CA;EAh0CA,0BAg0CA;EAh0CA,wBAg0CA;EAh0CA,yBAg0CA;EAh0CA,8BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA,yBAg0CA;EAh0CA,0BAg0CA;EAh0CA,wBAg0CA;EAh0CA,yBAg0CA;EAh0CA,8BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA,yBAg0CA;EAh0CA,0BAg0CA;EAh0CA,wBAg0CA;EAh0CA,yBAg0CA;EAh0CA,8BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA,yBAg0CA;EAh0CA,0BAg0CA;EAh0CA,wBAg0CA;EAh0CA,yBAg0CA;EAh0CA,8BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA,sBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,0BAg0CA;EAh0CA,qBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,mBAg0CA;EAh0CA;AAg0CA;AAh0CA;;EAAA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA,uBAg0CA;IAh0CA,sDAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA,uBAg0CA;IAh0CA,oDAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA,uBAg0CA;IAh0CA,2DAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA,mBAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA;EAg0CA;AAAA;AAh0CA;;EAAA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA,oBAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA,kBAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA,iBAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA,iBAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA,iBAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA,kBAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA,eAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA,kBAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA,mBAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA,mBAg0CA;IAh0CA;EAg0CA;AAAA;AAh0CA;;EAAA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;;EAh0CA;IAAA;EAg0CA;AAAA;AAh0CA;;EAAA;IAAA;EAg0CA;;EAh0CA;IAAA,eAg0CA;IAh0CA;EAg0CA;;EAh0CA;IAAA,iBAg0CA;IAh0CA;EAg0CA;AAAA;AAh0CA;EAAA,kBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,iCAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,gCAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,gCAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,iCAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,iCAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,qBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,gBAg0CA;EAh0CA,oBAg0CA;EAh0CA,4BAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,sBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,WAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,kBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,mBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,qBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,kBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA,oBAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA,WAg0CA;EAh0CA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA;AAh0CA;EAAA;AAg0CA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Chivo:wght@300;400;500;600;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  :root,\n  .dark {\n    /* ── Deep space palette (colored darks, not flat black) ── */\n    --bg:           228 32% 7%;    /* #0A0E18 */\n    --bg-paper:     230 28% 11%;   /* #121826 */\n    --bg-surface:   232 26% 15%;   /* #1A2234 */\n    --ink:          210 40% 97%;   /* #F5F9FC */\n    --ink-mute:     215 22% 68%;   /* #A3B2C8 */\n    --ink-dim:      215 16% 50%;   /* #6E809A */\n    --line:         228 22% 24%;   /* #2E3648 */\n    --line-subtle:  228 22% 16%;\n    --accent-cyan:  192 100% 50%;  /* #00D4FF */\n    --accent-amber: 38 92% 50%;    /* #F59E0B */\n    --accent-violet:270 80% 65%;   /* #9B59F5 */\n    --grid-line:    255 255 255 / 0.04;\n    --hero-grad-1:  0 212 255 / 0.08;\n    --hero-grad-2:  245 158 11 / 0.06;\n    --bg-noise:     0.025;\n    --orb-opacity:  0.6;\n    --bg-section:   228 28% 9%;\n    --bg-card-a:    215 32% 13%;   /* deep cyan-slate */\n    --bg-card-b:    235 28% 15%;   /* navy blue */\n    --bg-card-c:    252 24% 17%;   /* deep violet-slate */\n  }\n\n  .light {\n    --bg:           220 22% 97%;\n    --bg-paper:     220 20% 94%;\n    --bg-surface:   220 18% 90%;\n    --ink:          224 50% 9%;\n    --ink-mute:     215 18% 32%;\n    --ink-dim:      215 14% 45%;\n    --line:         220 18% 82%;\n    --line-subtle:  220 18% 90%;\n    --accent-cyan:  193 90% 26%;\n    --accent-amber: 32 92% 30%;\n    --accent-violet:270 70% 45%;\n    --grid-line:    0 0 0 / 0.04;\n    --hero-grad-1:  0 212 255 / 0.10;\n    --hero-grad-2:  245 158 11 / 0.08;\n    --bg-noise:     0.012;\n    --orb-opacity:  0.22;\n    --bg-section:   215 24% 93%;\n    --bg-card-a:    220 26% 99%;\n    --bg-card-b:    215 24% 95%;\n    --bg-card-c:    220 20% 97%;\n  }\n\n  html { scroll-behavior: smooth; }\n  body {\n    @apply bg-bg text-ink font-body antialiased;\n    transition: background-color 0.35s ease, color 0.35s ease;\n  }\n  h1, h2, h3, h4 { @apply font-heading text-ink; }\n  ::selection { background: #00D4FF33; color: #00D4FF; }\n}\n\n@layer utilities {\n  .container-x { @apply max-w-7xl mx-auto px-6 md:px-12; }\n\n  .label-eyebrow {\n    @apply font-mono text-[10px] tracking-widest2 uppercase font-semibold;\n    color: hsl(var(--accent-cyan));\n  }\n\n  /* ── Grid / texture ── */\n  .grid-bg {\n    background-image:\n      linear-gradient(rgb(var(--grid-line)) 1px, transparent 1px),\n      linear-gradient(90deg, rgb(var(--grid-line)) 1px, transparent 1px);\n    background-size: 56px 56px;\n  }\n  .noise::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    opacity: var(--bg-noise);\n    mix-blend-mode: overlay;\n    background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%25' height='100%25' filter='url(%23n)' opacity='1'/></svg>\");\n  }\n  .dot-pattern {\n    background-image: radial-gradient(rgb(var(--grid-line)) 1px, transparent 1.5px);\n    background-size: 18px 18px;\n  }\n\n  /* ── Orbs ── */\n  .orb {\n    position: absolute;\n    border-radius: 9999px;\n    filter: blur(100px);\n    pointer-events: none;\n    opacity: var(--orb-opacity);\n  }\n  .orb-cyan    { background: radial-gradient(circle, rgba(0,212,255,0.5), transparent 70%); }\n  .orb-amber   { background: radial-gradient(circle, rgba(245,158,11,0.45), transparent 70%); }\n  .orb-violet  { background: radial-gradient(circle, rgba(155,89,245,0.4), transparent 70%); }\n\n  /* ── Flow ── */\n  .stroke-flow { stroke-dasharray: 4 8; animation: flow 3s linear infinite; }\n\n  /* ── Gradient text ── */\n  .text-grad-cyan {\n    background: linear-gradient(135deg, #00D4FF 0%, #33DDFF 50%, #F59E0B 100%);\n    -webkit-background-clip: text; background-clip: text; color: transparent;\n  }\n  .text-grad-hero {\n    background: linear-gradient(118deg, #ffffff 0%, #E0F7FF 40%, #00D4FF 75%, #9B59F5 100%);\n    -webkit-background-clip: text; background-clip: text; color: transparent;\n  }\n\n  /* ── Theme accent text ── */\n  .text-accent-cyan   { color: hsl(var(--accent-cyan)); }\n  .text-accent-amber  { color: hsl(var(--accent-amber)); }\n  .text-accent-violet { color: hsl(var(--accent-violet)); }\n\n  /* ── Site nav — soft default, cyan hover/active ── */\n  .site-nav-link {\n    position: relative;\n    color: hsl(var(--ink-mute) / 0.78);\n    transition: color 0.2s ease;\n  }\n  .site-nav-link:hover,\n  .site-nav-link:focus-visible {\n    color: #ffffff;\n  }\n  .site-nav-link::after {\n    content: \"\";\n    position: absolute;\n    left: 0.75rem;\n    right: 0.75rem;\n    bottom: 0.35rem;\n    height: 1px;\n    background: hsl(var(--accent-cyan));\n    transform: scaleX(0);\n    transform-origin: center;\n    transition: transform 0.22s ease;\n    opacity: 0.85;\n  }\n  .site-nav-link:hover::after,\n  .site-nav-link:focus-visible::after,\n  .site-nav-link.is-open::after {\n    transform: scaleX(1);\n  }\n  .site-nav-link.is-open {\n    color: hsl(var(--accent-cyan));\n  }\n  .site-nav-chevron {\n    color: hsl(var(--ink-mute) / 0.55);\n    transition: color 0.2s ease, transform 0.2s ease;\n  }\n  .site-nav-link:hover .site-nav-chevron,\n  .site-nav-link:focus-visible .site-nav-chevron,\n  .site-nav-link.is-open .site-nav-chevron {\n    color: hsl(var(--accent-cyan));\n  }\n  .site-nav-dropdown {\n    background: hsl(var(--bg-paper));\n    border: 1px solid hsl(var(--accent-cyan) / 0.14);\n    box-shadow:\n      0 18px 48px rgba(0, 0, 0, 0.42),\n      0 0 0 1px hsl(var(--accent-cyan) / 0.05);\n  }\n  .site-nav-dropdown-item {\n    transition: background-color 0.18s ease;\n  }\n  .site-nav-dropdown-item:hover,\n  .site-nav-dropdown-item:focus-visible {\n    background: hsl(var(--accent-cyan) / 0.07);\n  }\n  .site-nav-dropdown-item__title {\n    color: hsl(var(--ink) / 0.92);\n    transition: color 0.18s ease;\n  }\n  .site-nav-dropdown-item:hover .site-nav-dropdown-item__title,\n  .site-nav-dropdown-item:focus-visible .site-nav-dropdown-item__title {\n    color: hsl(var(--accent-cyan));\n  }\n  .site-nav-lang-btn {\n    color: hsl(var(--ink-mute) / 0.78);\n    transition: color 0.2s ease, background-color 0.2s ease;\n  }\n  .site-nav-lang-btn:hover {\n    color: #ffffff;\n  }\n  .site-nav-mobile-link {\n    color: hsl(var(--ink-mute) / 0.82);\n    transition: color 0.2s ease;\n  }\n  .site-nav-mobile-link:hover,\n  .site-nav-mobile-link:focus-visible {\n    color: hsl(var(--accent-cyan));\n  }\n  .site-nav-mobile-toggle {\n    color: hsl(var(--ink-mute) / 0.78);\n    transition: color 0.2s ease;\n  }\n  .site-nav-mobile-toggle:hover,\n  .site-nav-mobile-toggle.is-open {\n    color: hsl(var(--accent-cyan));\n  }\n  .site-nav-mobile-sub {\n    color: hsl(var(--ink-mute) / 0.78);\n    transition: color 0.18s ease;\n  }\n  .site-nav-mobile-sub:hover,\n  .site-nav-mobile-sub:focus-visible {\n    color: hsl(var(--accent-cyan));\n  }\n\n  /* ── Hero ── */\n  .hero-video-wrap {\n    position: absolute; inset: 0; overflow: hidden;\n    background: hsl(225 35% 5%);\n  }\n  .hero-video-wrap video {\n    position: absolute; inset: 0; width: 100%; height: 100%;\n    object-fit: cover;\n    object-position: 58% 46%;\n    filter: none;\n    z-index: 0;\n    backface-visibility: hidden;\n    will-change: auto;\n  }\n  /* Sol-alt banding bölgesini düz renkle kapat — chip renklerine dokunmaz */\n  .hero-video-scrim {\n    position: absolute; inset: 0; z-index: 1;\n    pointer-events: none;\n    background:\n      hsl(228 32% 4% / 0.36),\n      linear-gradient(\n        to right,\n        hsl(225 35% 5% / 0.96) 0%,\n        hsl(225 35% 5% / 0.72) 24%,\n        hsl(225 35% 5% / 0.28) 44%,\n        transparent 58%\n      ),\n      linear-gradient(\n        to top,\n        hsl(225 35% 5% / 0.82) 0%,\n        hsl(225 35% 5% / 0.35) 22%,\n        transparent 42%\n      );\n  }\n  .hero-video-wrap--ended .hero-video-scrim {\n    background:\n      hsl(228 32% 4% / 0.42),\n      linear-gradient(\n        to right,\n        hsl(225 35% 5% / 0.98) 0%,\n        hsl(225 35% 5% / 0.78) 26%,\n        hsl(225 35% 5% / 0.32) 46%,\n        transparent 60%\n      ),\n      linear-gradient(\n        to top,\n        hsl(225 35% 5% / 0.88) 0%,\n        hsl(225 35% 5% / 0.42) 24%,\n        transparent 44%\n      );\n  }\n  /* Orta metin okunabilirliği — video ile uyumlu vignette */\n  .hero-cinematic-scrim {\n    position: absolute; inset: 0; z-index: 1;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity 0.7s ease;\n    background:\n      radial-gradient(\n        ellipse 85% 68% at 50% 48%,\n        hsl(225 35% 5% / 0.88) 0%,\n        hsl(225 35% 5% / 0.52) 40%,\n        hsl(225 35% 5% / 0.18) 68%,\n        transparent 82%\n      );\n  }\n  .hero-cinematic-scrim--active {\n    opacity: 1;\n  }\n  /* Sinematik hero yazıları — video altyazısı / title card hissi */\n  .hero-cinematic-block {\n    text-shadow:\n      0 0 40px rgba(0, 0, 0, 0.95),\n      0 4px 24px rgba(0, 0, 0, 0.9),\n      0 8px 48px rgba(0, 0, 0, 0.65);\n  }\n  .hero-cinematic-headline {\n    @apply font-heading;\n    font-weight: 900;\n    letter-spacing: -0.01em;\n    line-height: 1.12;\n    font-size: clamp(1.85rem, 4.5vw, 3.25rem);\n  }\n  .hero-cinematic-lead {\n    color: rgba(255, 255, 255, 0.92);\n    font-weight: 600;\n    line-height: 1.35;\n    letter-spacing: 0.005em;\n    font-size: clamp(1.35rem, 3.4vw, 2.35rem);\n  }\n  .hero-cinematic-body {\n    @apply font-heading;\n    color: rgba(255, 255, 255, 0.94);\n    font-weight: 800;\n    line-height: 1.22;\n    letter-spacing: 0;\n    font-size: clamp(2.1rem, 5.5vw, 4rem);\n  }\n  .hero-cinematic-tagline {\n    @apply font-heading;\n    font-weight: 900;\n    letter-spacing: -0.008em;\n    line-height: 1.15;\n    font-size: clamp(2.75rem, 7.5vw, 5.5rem);\n  }\n  .hero-cinematic-tagline--readable {\n    letter-spacing: 0.012em;\n    word-spacing: 0.08em;\n    line-height: 1.14;\n    font-size: clamp(2.5rem, 7vw, 5rem);\n  }\n  /* Infra AI wordmark — Infra düz beyaz, AI parlak cyan (tüm sayfa) */\n  .infra-ai-wordmark {\n    @apply inline-flex items-baseline;\n    gap: 0.22em;\n    letter-spacing: -0.02em;\n    line-height: 1;\n  }\n  .infra-ai-wordmark--inline {\n    font-size: inherit;\n    font-weight: inherit;\n    font-family: inherit;\n    letter-spacing: inherit;\n  }\n  .infra-ai-wordmark--inline .hero-logo-infra {\n    color: hsl(var(--ink));\n    -webkit-text-fill-color: hsl(var(--ink));\n    text-shadow: none;\n  }\n  .infra-ai-wordmark--inline .hero-logo-ai {\n    color: #00d4ff;\n    -webkit-text-fill-color: #00d4ff;\n  }\n  .infra-ai-wordmark--sm {\n    @apply font-heading font-semibold;\n    letter-spacing: -0.02em;\n  }\n  .infra-ai-wordmark--sm .hero-logo-infra {\n    color: inherit;\n    -webkit-text-fill-color: currentColor;\n    text-shadow: none;\n  }\n  .hero-logo-wordmark {\n    @apply font-heading font-black infra-ai-wordmark;\n    font-size: clamp(2.25rem, 6.5vw, 4.5rem);\n    filter: drop-shadow(0 2px 16px rgba(0, 0, 0, 0.65));\n  }\n  .hero-logo-infra {\n    color: #ffffff;\n    -webkit-text-fill-color: #ffffff;\n    text-shadow:\n      0 2px 16px rgba(0, 0, 0, 0.55),\n      0 0 1px rgba(255, 255, 255, 0.8);\n  }\n  .hero-logo-ai {\n    color: #00d4ff;\n    -webkit-text-fill-color: #00d4ff;\n    text-shadow: 0 0 28px rgba(0, 212, 255, 0.5);\n  }\n  .hero-logo-wordmark .hero-logo-ai {\n    filter: drop-shadow(0 0 22px rgba(0, 212, 255, 0.4));\n  }\n  .hero-cinematic-accent {\n    color: #00d4ff;\n  }\n  .hero-text-shadow {\n    text-shadow:\n      0 2px 24px rgba(0, 0, 0, 0.85),\n      0 4px 48px rgba(0, 0, 0, 0.55);\n  }\n\n  /* ── About video ── */\n  .about-video-wrap {\n    position: relative;\n    min-height: 280px;\n  }\n  @media (min-width: 1024px) {\n    .about-video-wrap {\n      min-height: 360px;\n    }\n  }\n  .about-video-wrap video.about-video {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center center;\n    transform: translateZ(0);\n    backface-visibility: hidden;\n  }\n  .about-video-scrim {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    z-index: 1;\n    background:\n      linear-gradient(to top, hsl(225 35% 5% / 0.55) 0%, transparent 38%),\n      linear-gradient(to right, transparent 55%, hsl(225 35% 5% / 0.35) 100%);\n  }\n  /* Sağ alt — video filigranını (MINIMAX / Hailuo) gizle */\n  .about-video-watermark-mask {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: min(42%, 11.5rem);\n    height: min(22%, 4.25rem);\n    z-index: 2;\n    pointer-events: none;\n    background: linear-gradient(\n      145deg,\n      transparent 0%,\n      hsl(228 28% 6% / 0.72) 38%,\n      hsl(225 35% 4% / 0.97) 68%,\n      hsl(222 38% 3% / 1) 100%\n    );\n    box-shadow: -12px -8px 28px hsl(225 35% 4% / 0.85);\n  }\n  .about-video-wrap--ended .about-video {\n    will-change: auto;\n  }\n  .about-video-end-wordmark {\n    position: absolute;\n    left: 7%;\n    bottom: 6%;\n    z-index: 3;\n    opacity: 0;\n    transform: translateY(10px);\n    transition:\n      opacity 0.65s cubic-bezier(0.22, 1, 0.36, 1),\n      transform 0.65s cubic-bezier(0.22, 1, 0.36, 1);\n    pointer-events: none;\n  }\n  .about-video-end-wordmark.is-visible {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  .about-video-end-wordmark__brand {\n    font-family: \"Outfit\", sans-serif;\n    font-size: clamp(1.35rem, 3.4vw, 2.1rem);\n    font-weight: 900;\n    letter-spacing: -0.02em;\n    line-height: 1;\n    filter: drop-shadow(0 2px 18px rgba(0, 0, 0, 0.85));\n  }\n  .about-video-end-wordmark__brand .hero-logo-infra {\n    color: #ffffff;\n    -webkit-text-fill-color: #ffffff;\n    text-shadow:\n      0 2px 14px rgba(0, 0, 0, 0.75),\n      0 0 1px rgba(255, 255, 255, 0.85);\n  }\n  .about-video-end-wordmark__brand .hero-logo-ai {\n    color: #00d4ff;\n    -webkit-text-fill-color: #00d4ff;\n    text-shadow: 0 0 22px rgba(0, 212, 255, 0.55);\n  }\n  .about-video-end-wordmark__tagline {\n    margin: 0.5rem 0 0;\n    max-width: 16rem;\n    font-family: \"Outfit\", sans-serif;\n    font-size: clamp(0.95rem, 2.15vw, 1.32rem);\n    font-weight: 600;\n    letter-spacing: 0.01em;\n    line-height: 1.25;\n    background: linear-gradient(\n      90deg,\n      #48cae4 0%,\n      #56b8ff 18%,\n      #6ea3f7 42%,\n      #9b8cf8 68%,\n      #c084fc 100%\n    );\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n    -webkit-text-fill-color: transparent;\n    filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.78));\n  }\n\n  #emergent-badge { display: none !important; }\n  .hero-badge {\n    @apply flex items-center gap-2 px-3 py-2 border border-white/10 bg-white/5 backdrop-blur-sm text-[11px] font-mono text-white/70;\n  }\n  .hero-engine-wrap {\n    @apply border border-line/70 overflow-hidden;\n    background: hsl(var(--bg-card-b));\n  }\n  .dark .hero-engine-wrap {\n    background: hsl(var(--bg-paper) / 0.65);\n  }\n\n  /* ── Marquee / Logo band ── */\n  .marquee-track {\n    display: flex;\n    gap: 0;\n    animation: marquee 32s linear infinite;\n    width: max-content;\n  }\n  .marquee-track:hover { animation-play-state: paused; }\n\n  /* ── Scroll reveal ── */\n  .reveal {\n    opacity: 0;\n    transform: translateY(40px) scale(0.98);\n    filter: blur(5px);\n    transition:\n      opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1),\n      transform 0.8s cubic-bezier(0.22, 1, 0.36, 1),\n      filter 0.65s cubic-bezier(0.22, 1, 0.36, 1);\n    will-change: opacity, transform;\n  }\n  .reveal.revealed {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n    filter: blur(0);\n    will-change: auto;\n  }\n  .reveal-left {\n    opacity: 0;\n    transform: translateX(-40px);\n    filter: blur(4px);\n    transition:\n      opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1),\n      transform 0.8s cubic-bezier(0.22, 1, 0.36, 1),\n      filter 0.65s cubic-bezier(0.22, 1, 0.36, 1);\n  }\n  .reveal-right {\n    opacity: 0;\n    transform: translateX(40px);\n    filter: blur(4px);\n    transition:\n      opacity 0.8s cubic-bezier(0.22, 1, 0.36, 1),\n      transform 0.8s cubic-bezier(0.22, 1, 0.36, 1),\n      filter 0.65s cubic-bezier(0.22, 1, 0.36, 1);\n  }\n  .reveal-left.revealed,\n  .reveal-right.revealed {\n    opacity: 1;\n    transform: translateX(0);\n    filter: blur(0);\n  }\n\n  /* stagger — kartlar sırayla (JS delay + CSS yedek) */\n  .stagger > *:nth-child(1) { transition-delay: 0ms; }\n  .stagger > *:nth-child(2) { transition-delay: 90ms; }\n  .stagger > *:nth-child(3) { transition-delay: 180ms; }\n  .stagger > *:nth-child(4) { transition-delay: 270ms; }\n  .stagger > *:nth-child(5) { transition-delay: 360ms; }\n  .stagger > *:nth-child(6) { transition-delay: 450ms; }\n  .stagger > *:nth-child(7) { transition-delay: 540ms; }\n  .stagger > *:nth-child(8) { transition-delay: 630ms; }\n  .stagger > *:nth-child(9) { transition-delay: 720ms; }\n  .stagger > *:nth-child(10) { transition-delay: 810ms; }\n  .stagger > *:nth-child(11) { transition-delay: 900ms; }\n  .stagger > *:nth-child(12) { transition-delay: 990ms; }\n\n  /* ── Premium card ── */\n  .card-premium {\n    position: relative;\n    overflow: hidden;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  .card-premium::before {\n    content: \"\";\n    position: absolute; inset: 0;\n    background: linear-gradient(135deg, rgba(0,212,255,0.06) 0%, rgba(155,89,245,0.04) 45%, transparent 70%);\n    pointer-events: none;\n    opacity: 0.55;\n    transition: opacity 0.3s ease;\n  }\n  .card-premium:hover::before { opacity: 1; }\n  .card-premium:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 16px 40px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,212,255,0.1);\n  }\n\n  /* ── Metrics count ── */\n  .count-cell { font-variant-numeric: tabular-nums; }\n\n  /* ── Separator line ── */\n  .sep-line {\n    height: 1px;\n    background: linear-gradient(90deg, transparent 0%, hsl(var(--line)) 25%, hsl(var(--line)) 75%, transparent 100%);\n  }\n\n  /* ── Why InfraAI ── */\n  .why-infraai {\n    background: hsl(var(--bg));\n    position: relative;\n  }\n  .why-infraai::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background-image:\n      linear-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px),\n      linear-gradient(90deg, rgba(255, 255, 255, 0.025) 1px, transparent 1px);\n    background-size: 56px 56px;\n    mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 0%, transparent 75%);\n    pointer-events: none;\n  }\n  .why-infraai-glow {\n    position: absolute;\n    top: -120px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 680px;\n    height: 420px;\n    background: radial-gradient(circle, rgba(0, 212, 255, 0.10), transparent 70%);\n    filter: blur(40px);\n    pointer-events: none;\n  }\n  .why-eyebrow {\n    display: inline-flex;\n    align-items: center;\n    gap: 9px;\n    margin-bottom: 22px;\n    font-family: \"JetBrains Mono\", monospace;\n    font-size: 11px;\n    letter-spacing: 0.28em;\n    text-transform: uppercase;\n    color: #00d4ff;\n    font-weight: 600;\n  }\n  .why-eyebrow-dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #00d4ff;\n    box-shadow: 0 0 12px #00d4ff;\n    animation: why-pulse 2.4s ease-in-out infinite;\n  }\n  .why-chain {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    border: 1px solid hsl(var(--line));\n    border-radius: 14px;\n    overflow: hidden;\n    background: linear-gradient(180deg, rgba(18, 24, 38, 0.9), rgba(10, 14, 24, 0.9));\n  }\n  .why-chain-step {\n    position: relative;\n    padding: 26px 22px 30px;\n    border-right: 1px solid #1e2535;\n    transition:\n      opacity 0.5s ease,\n      background 0.5s ease,\n      box-shadow 0.5s ease,\n      transform 0.5s ease;\n  }\n  .why-chain-step:not(.why-chain-step--active) {\n    opacity: 0.48;\n  }\n  .why-chain-step--active {\n    opacity: 1;\n    z-index: 1;\n    transform: translateY(-2px);\n  }\n  .why-chain-step--active.why-chain-step--nai {\n    background: rgba(0, 212, 255, 0.09);\n    box-shadow:\n      inset 0 3px 0 #00d4ff,\n      0 0 32px rgba(0, 212, 255, 0.14);\n  }\n  .why-chain-step--active.why-chain-step--rival {\n    background: rgba(245, 158, 11, 0.12);\n    box-shadow:\n      inset 0 3px 0 #f59e0b,\n      0 0 32px rgba(245, 158, 11, 0.16);\n  }\n  .why-chain-step--active.why-chain-step--rival .why-chain-verb {\n    color: #fbbf24;\n  }\n  .why-chain-step--active.why-chain-step--rival .font-mono {\n    color: #f59e0b;\n    opacity: 1;\n  }\n  .why-chain-step--active.why-chain-step--nai .font-mono {\n    opacity: 1;\n  }\n  .why-chain-step:last-child { border-right: 0; }\n  .why-chain-step--rival {\n    background: rgba(245, 158, 11, 0.04);\n    border-right: 1px dashed rgba(245, 158, 11, 0.55);\n    padding-bottom: 58px;\n  }\n  .why-chain-step--rival .why-chain-verb { color: hsl(var(--ink-mute)); }\n  .why-chain-step--rival .font-mono { color: hsl(var(--ink-dim)); }\n  .why-chain-step--nai .why-chain-verb { color: #00d4ff; }\n  .why-chain-step--nai .font-mono { color: #00d4ff; opacity: 0.65; }\n  .why-chain-verb {\n    font-family: \"Outfit\", sans-serif;\n    font-weight: 700;\n    font-size: 21px;\n    letter-spacing: -0.01em;\n    margin-bottom: 7px;\n  }\n  .why-rival-label {\n    position: absolute;\n    bottom: 14px;\n    left: 14px;\n    right: 14px;\n    display: block;\n    text-align: center;\n    font-family: \"JetBrains Mono\", monospace;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    line-height: 1.35;\n    text-transform: uppercase;\n    color: #fbbf24;\n    padding: 7px 10px;\n    border: 1px solid rgba(245, 158, 11, 0.65);\n    border-radius: 6px;\n    background: rgba(245, 158, 11, 0.14);\n    box-shadow:\n      0 0 20px rgba(245, 158, 11, 0.2),\n      inset 0 1px 0 rgba(255, 255, 255, 0.06);\n  }\n  .why-flowline {\n    height: 2px;\n    border-radius: 2px;\n    background: linear-gradient(\n      90deg,\n      transparent 0%, transparent 25%,\n      #00d4ff 35%, #9b59f5 75%, transparent 100%\n    );\n    background-size: 200% 100%;\n    animation: why-flow 3.2s linear infinite;\n    opacity: 0.8;\n  }\n  .why-pillars {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n  }\n  .why-pillar {\n    position: relative;\n    display: grid;\n    grid-template-rows: auto auto 1fr auto;\n    background: hsl(var(--bg-paper));\n    border: 1px solid hsl(var(--line));\n    border-radius: 13px;\n    padding: 24px 22px 22px;\n    overflow: hidden;\n    transition: transform 0.3s ease, border-color 0.3s ease;\n  }\n  .why-pillar::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(150deg, rgba(0, 212, 255, 0.07), transparent 55%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    pointer-events: none;\n  }\n  .why-pillar:hover {\n    transform: translateY(-4px);\n    border-color: rgba(0, 212, 255, 0.35);\n  }\n  .why-pillar:hover::before { opacity: 1; }\n  .why-pillar-icon {\n    width: 4.5rem;\n    height: 4.5rem;\n    margin-bottom: 18px;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n  }\n  .neon-icon-wrap {\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-start;\n  }\n  .neon-icon-wrap img {\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    object-position: left bottom;\n    display: block;\n  }\n  .why-pillar-body {\n    align-self: start;\n  }\n  .why-term {\n    padding-top: 14px;\n  }\n  .why-term-box {\n    font-family: \"JetBrains Mono\", monospace;\n    font-size: 11px;\n    background: #060912;\n    border: 1px solid hsl(var(--line));\n    border-radius: 7px;\n    padding: 9px 11px;\n    color: hsl(var(--ink-mute));\n    line-height: 1.65;\n    min-height: 4.95em;\n  }\n  .why-t-cyan   { color: #00d4ff; }\n  .why-t-amber  { color: #f59e0b; }\n  .why-t-violet { color: #9b59f5; }\n  .why-t-green  { color: #4ade80; }\n  .why-t-red    { color: #f87171; }\n  .why-t-dim    { color: hsl(var(--ink-dim)); }\n  .why-t-arrow  { color: #00d4ff; }\n  .why-stat-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 10px 18px;\n  }\n  .why-stat-div {\n    width: 1px;\n    height: 18px;\n    background: hsl(var(--line));\n  }\n  @media (max-width: 860px) {\n    .why-chain { grid-template-columns: repeat(2, 1fr); }\n    .why-chain-step:nth-child(2) { border-right: 0; }\n    .why-chain-step--rival {\n      padding-bottom: 26px;\n    }\n    .why-rival-label {\n      position: static;\n      display: block;\n      margin-top: 12px;\n    }\n    .why-pillars { grid-template-columns: repeat(2, 1fr); }\n  }\n  @media (max-width: 520px) {\n    .why-chain,\n    .why-pillars { grid-template-columns: 1fr; }\n    .why-chain-step {\n      border-right: 0;\n      border-bottom: 1px solid #1e2535;\n    }\n    .why-chain-step--rival {\n      border-right: 0;\n      border-bottom: 1px dashed rgba(245, 158, 11, 0.5);\n    }\n  }\n  @media (prefers-reduced-motion: reduce) {\n    .why-flowline,\n    .why-eyebrow-dot { animation: none; }\n  }\n\n  /* ── Capabilities ── */\n  .capabilities {\n    background: hsl(var(--bg));\n    position: relative;\n  }\n  .positioning-hook {\n    max-width: 920px;\n    padding: 28px 0 8px;\n    border-left: 3px solid #00d4ff;\n    padding-left: 28px;\n  }\n  .positioning-hook-before {\n    font-family: \"Outfit\", sans-serif;\n    font-size: clamp(1.125rem, 2.2vw, 1.5rem);\n    font-weight: 500;\n    color: hsl(var(--ink-mute));\n    line-height: 1.45;\n    margin: 0 0 14px;\n  }\n  .positioning-hook-after {\n    font-family: \"Outfit\", sans-serif;\n    font-size: clamp(1.35rem, 3vw, 2rem);\n    font-weight: 700;\n    color: hsl(var(--ink));\n    line-height: 1.35;\n    letter-spacing: -0.02em;\n    margin: 0;\n  }\n  .capabilities-hero-grid {\n    min-height: 280px;\n  }\n  @media (min-width: 1024px) {\n    .capabilities-hero-grid {\n      min-height: 320px;\n    }\n  }\n  .capabilities-hero-card {\n    min-height: 280px;\n    background: hsl(var(--bg-paper));\n    border: 1px solid hsl(var(--line) / 0.65);\n    border-radius: 14px;\n    padding: 28px 24px;\n    box-shadow: 0 0 80px rgba(0, 212, 255, 0.06);\n  }\n  @media (min-width: 768px) {\n    .capabilities-hero-card {\n      padding: 32px 28px;\n    }\n  }\n  @media (min-width: 1024px) {\n    .capabilities-hero-card {\n      min-height: 320px;\n      padding: 36px 32px;\n    }\n  }\n  .capabilities-hero-card--media {\n    padding: 0;\n    overflow: hidden;\n  }\n  .capabilities-hero-card--media .about-video-wrap {\n    min-height: 280px;\n    border-radius: inherit;\n  }\n  @media (min-width: 1024px) {\n  .capabilities-hero-card--media .about-video-wrap {\n    min-height: 320px;\n    }\n  }\n  /* Sol metin kartı — çerçevede dönen beyaz ışık huzmesi */\n  .capabilities-hero-card--border-beam {\n    position: relative;\n    isolation: isolate;\n    overflow: hidden;\n    border-color: transparent;\n  }\n  .capabilities-hero-card--border-beam::before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 220%;\n    aspect-ratio: 1;\n    transform: translate(-50%, -50%) rotate(0deg);\n    opacity: 0;\n    background: conic-gradient(\n      from 0deg,\n      transparent 0deg 318deg,\n      rgba(255, 255, 255, 0.18) 326deg,\n      rgba(255, 255, 255, 0.85) 336deg,\n      rgba(255, 255, 255, 1) 343deg,\n      rgba(255, 255, 255, 0.85) 350deg,\n      rgba(255, 255, 255, 0.18) 358deg,\n      transparent 360deg\n    );\n    animation: none;\n    z-index: 0;\n    pointer-events: none;\n  }\n  .capabilities-hero-card--border-beam.revealed {\n    animation: capabilities-border-beam-card-settle 5.4s linear 1 forwards;\n  }\n  @keyframes capabilities-border-beam-card-settle {\n    0%,\n    92% {\n      border-color: transparent;\n    }\n    100% {\n      border-color: hsl(var(--line) / 0.65);\n    }\n  }\n  .capabilities-hero-card--border-beam.revealed::before {\n    opacity: 1;\n    animation: capabilities-border-beam-spin 5s linear 0.4s 1 forwards;\n  }\n  .capabilities-hero-card--border-beam::after {\n    content: \"\";\n    position: absolute;\n    inset: 1.5px;\n    border-radius: 12.5px;\n    background: hsl(var(--bg-paper));\n    z-index: 0;\n    pointer-events: none;\n  }\n  .capabilities-hero-card--border-beam > * {\n    position: relative;\n    z-index: 1;\n  }\n  @keyframes capabilities-border-beam-spin {\n    0% {\n      transform: translate(-50%, -50%) rotate(0deg);\n      opacity: 1;\n    }\n    92% {\n      opacity: 1;\n    }\n    100% {\n      transform: translate(-50%, -50%) rotate(360deg);\n      opacity: 0;\n    }\n  }\n  @media (prefers-reduced-motion: reduce) {\n    .capabilities-hero-card--border-beam::before {\n      animation: none;\n      opacity: 0;\n    }\n    .capabilities-hero-card--border-beam,\n    .capabilities-hero-card--border-beam.revealed {\n      animation: none;\n      border-color: hsl(var(--line) / 0.65);\n    }\n  }\n  .capabilities-cards-title {\n    display: flex;\n    align-items: baseline;\n    flex-wrap: wrap;\n    gap: 0.1em;\n    font-family: \"Outfit\", sans-serif;\n    font-size: clamp(1.625rem, 3.2vw, 2.125rem);\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    color: hsl(var(--ink));\n  }\n  .capabilities-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 16px;\n    align-items: stretch;\n  }\n  @media (min-width: 768px) {\n    .capabilities-grid {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n  @media (min-width: 1280px) {\n    .capabilities-grid {\n      grid-template-columns: repeat(3, 1fr);\n    }\n  }\n  .capability-card {\n    position: relative;\n    display: grid;\n    grid-template-rows: auto auto auto 1fr;\n    height: 100%;\n    min-height: 100%;\n    background: hsl(var(--bg-paper));\n    border: 1px solid hsl(var(--line));\n    border-radius: 14px;\n    padding: 26px 24px 24px;\n    overflow: hidden;\n    transition: transform 0.3s ease, border-color 0.3s ease;\n  }\n  .capability-card::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(155deg, rgba(0, 212, 255, 0.05), transparent 58%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    pointer-events: none;\n  }\n  .capability-card:hover {\n    transform: translateY(-3px);\n    border-color: rgba(0, 212, 255, 0.28);\n  }\n  .capability-card:hover::before { opacity: 1; }\n  .capability-badge {\n    display: inline-block;\n    margin-bottom: 18px;\n    font-family: \"JetBrains Mono\", monospace;\n    font-size: 9.5px;\n    font-weight: 700;\n    letter-spacing: 0.16em;\n    padding: 5px 9px;\n    border-radius: 5px;\n  }\n  .capability-badge--compliance {\n    color: #fbbf24;\n    border: 1px solid rgba(245, 158, 11, 0.5);\n    background: rgba(245, 158, 11, 0.1);\n  }\n  .capability-badge--proven {\n    color: #00d4ff;\n    border: 1px solid rgba(0, 212, 255, 0.45);\n    background: rgba(0, 212, 255, 0.08);\n  }\n  .capability-badge--deployment {\n    color: #4ade80;\n    border: 1px solid rgba(74, 222, 128, 0.45);\n    background: rgba(74, 222, 128, 0.08);\n  }\n  .capability-icon {\n    width: 4.5rem;\n    height: 4.5rem;\n    margin-bottom: 16px;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n  }\n  .capability-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 11px;\n  }\n  .capability-list li {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    font-size: 13.5px;\n    line-height: 1.55;\n    color: hsl(var(--ink-mute));\n  }\n  .capability-check {\n    flex-shrink: 0;\n    margin-top: 2px;\n    font-family: \"JetBrains Mono\", monospace;\n    font-size: 11px;\n    font-weight: 700;\n    color: #4ade80;\n  }\n  .partner-logo-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1px;\n    background: hsl(var(--line));\n  }\n  @media (min-width: 640px) {\n    .partner-logo-grid {\n      grid-template-columns: repeat(4, 1fr);\n    }\n  }\n  @media (min-width: 768px) {\n    .partner-logo-grid {\n      grid-template-columns: repeat(6, 1fr);\n    }\n  }\n  .partner-logo-cell {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 72px;\n    padding: 20px 16px;\n    transition: background 0.2s ease;\n  }\n  .partner-logo-cell:hover {\n    background: hsl(var(--bg-surface));\n  }\n  .partner-logo-img {\n    width: auto;\n    height: 28px;\n    max-width: 100%;\n    object-fit: contain;\n    opacity: 0.55;\n    filter: grayscale(1) brightness(0);\n    transition: opacity 0.2s ease;\n  }\n  .dark .partner-logo-img {\n    filter: grayscale(1) brightness(0) invert(1);\n  }\n  .partner-logo-cell:hover .partner-logo-img {\n    opacity: 0.85;\n  }\n  .nav-dropdown-desc {\n    color: hsl(var(--ink-mute) / 0.92);\n    font-weight: 500;\n    line-height: 1.45;\n  }\n  .nav-dropdown-footer {\n    flex-shrink: 0;\n  }\n  .form-trust-band {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  .form-trust-band__item {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    font-size: 14px;\n    line-height: 1.55;\n    color: hsl(var(--ink-mute));\n  }\n  .form-trust-band__check {\n    flex-shrink: 0;\n    margin-top: 2px;\n    font-size: 13px;\n    font-weight: 700;\n    color: hsl(var(--accent-cyan));\n  }\n  .about-stat-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    min-height: 108px;\n  }\n  .partners-footer-quote {\n    margin: 0;\n    padding: 14px 24px 16px;\n    border-top: 1px solid hsl(var(--line));\n    font-family: \"JetBrains Mono\", monospace;\n    font-size: 10.5px;\n    letter-spacing: 0.03em;\n    line-height: 1.65;\n    color: hsl(var(--ink-dim));\n    text-align: center;\n  }\n\n  /* ── Use Cases (legacy card styles kept for reuse) ── */\n  .use-cases {\n    background: hsl(var(--bg));\n    position: relative;\n  }\n  .use-cases-glow {\n    position: absolute;\n    top: -80px;\n    right: -120px;\n    width: 520px;\n    height: 360px;\n    background: radial-gradient(circle, rgba(0, 212, 255, 0.08), transparent 70%);\n    filter: blur(40px);\n    pointer-events: none;\n  }\n  .use-cases-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 14px;\n  }\n  @media (min-width: 768px) {\n    .use-cases-grid {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 16px;\n    }\n  }\n  @media (min-width: 1280px) {\n    .use-cases-grid {\n      grid-template-columns: repeat(4, 1fr);\n    }\n  }\n  .use-case-card {\n    position: relative;\n    display: grid;\n    grid-template-rows: auto auto auto 1fr;\n    background: hsl(var(--bg-paper));\n    border: 1px solid hsl(var(--line));\n    border-radius: 13px;\n    padding: 22px 20px 20px;\n    overflow: hidden;\n    transition: transform 0.3s ease, border-color 0.3s ease;\n  }\n  .use-case-card::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(150deg, rgba(0, 212, 255, 0.06), transparent 55%);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    pointer-events: none;\n  }\n  .use-case-card:hover {\n    transform: translateY(-3px);\n    border-color: rgba(0, 212, 255, 0.32);\n  }\n  .use-case-card:hover::before { opacity: 1; }\n  .use-case-tag {\n    display: inline-block;\n    width: fit-content;\n    margin-bottom: 14px;\n    font-family: \"JetBrains Mono\", monospace;\n    font-size: 9.5px;\n    font-weight: 600;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: #fbbf24;\n    padding: 4px 8px;\n    border: 1px solid rgba(245, 158, 11, 0.45);\n    border-radius: 5px;\n    background: rgba(245, 158, 11, 0.1);\n  }\n  .use-case-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 212, 255, 0.08);\n    border: 1px solid rgba(0, 212, 255, 0.22);\n    margin-bottom: 16px;\n  }\n  .use-case-body {\n    min-height: 4.5rem;\n  }\n}\n\n/* ── Keyframes ── */\n@keyframes pulse-glow {\n  0%, 100% { opacity: 0.4; }\n  50%       { opacity: 1; }\n}\n@keyframes flow {\n  0%   { stroke-dashoffset: 200; }\n  100% { stroke-dashoffset: 0; }\n}\n@keyframes fade-up {\n  0%   { opacity: 0; transform: translateY(16px); }\n  100% { opacity: 1; transform: translateY(0); }\n}\n@keyframes marquee {\n  0%   { transform: translateX(0); }\n  100% { transform: translateX(-50%); }\n}\n@keyframes count-up-in {\n  from { opacity: 0; transform: translateY(20px) scale(0.92); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n@keyframes shimmer {\n  0%   { background-position: -200% center; }\n  100% { background-position: 200% center; }\n}\n@keyframes why-flow {\n  0%   { background-position: 150% 0; }\n  100% { background-position: -50% 0; }\n}\n@keyframes why-pulse {\n  0%, 100% { opacity: 0.4; }\n  50%       { opacity: 1; }\n}\n\n.animate-pulse-glow { animation: pulse-glow 2.5s ease-in-out infinite; }\n.animate-fade-up    { animation: fade-up 0.6s ease-out forwards; }\n.animate-count-in   { animation: count-up-in 0.5s ease-out forwards; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
